<template>
  <div class="block">
    <el-tag>选择账户： </el-tag>
    <div class="block">
      <el-cascader
        v-model="userUalue"
        :options="options1"
        filterable></el-cascader>
    </div>
    <el-divider direction="vertical"></el-divider>
    <el-tag>选择汇总方式：</el-tag>
    <el-select v-model="value" placeholder="请选择">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
    <el-divider direction="vertical"></el-divider>

    <el-tag>选择层级：</el-tag>
    <el-select v-model="values" placeholder="请选择">
      <el-option
        v-for="items in level"
        :key="items.value"
        :label="items.label"
        :value="items.value">
      </el-option>
    </el-select>
    <el-divider direction="vertical"></el-divider>

    <el-tag>输入起止日期：</el-tag>
    <el-date-picker

      v-model="value1"
      type="daterange"
      align="right"
      unlink-panels
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="yyyyMMdd"
      :picker-options="pickerOptions"
      @change="chooseTimeRange">
    </el-date-picker>
    <el-button type="primary" v-on:click="exportExcel" round>导出</el-button>
    <el-button type="primary" v-on:click="getDataList"  :disabled="isDisable" round>查询</el-button>
    <el-button type="primary" v-on:click="getDataList1"  :disabled="isDisable" round>一键调整</el-button>

    <el-divider></el-divider>
    <el-table
      XLSX.uitls.table_to_book
      stripe

      :default-sort = "{prop: 'date', order: 'descending'}"
      :data="datas"
      id="exportTab"
      :summary-method="getSummaries"
      show-summary
      style="width: 100%">
      <el-table-column
        sortable
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="campaignName"
        label="计划名称"
        width="180">


      </el-table-column>
      <el-table-column
        sortable
        v-if="['GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="groupId"
        label="广告组ID"
        width="100">
      </el-table-column>
      <el-table-column
        sortable
        v-if="['GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="groupName"
        label="广告组名称"
        width="200">
      </el-table-column>
      <el-table-column
        sortable
        v-if="['CAMPAIGN','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="campaignId"
        width="120"
        label="计划ID">
      </el-table-column>
      <el-table-column
        v-if="['ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="advertisementName"
        label="广告名称"
        width="300">
      </el-table-column>
      <el-table-column
        v-if="['CREATIVE'].includes(this.values)"
        prop="creativeId"
        label="创意ID">
      </el-table-column>
      <el-table-column
        v-if="['CREATIVE'].includes(this.values)"
        sortable
        width="120"
        prop="placeType"
        label="广告位类型">
      </el-table-column>
      <el-table-column
        v-if="['GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        sortable
        width="120"
        prop="cvType"
        label="转化类型">
      </el-table-column>
      <!-- 测试 -->
      <el-table-column
        prop="uuid"
        width="120"
        label="账户id">
      </el-table-column>
      <el-table-column
        sortable
        prop="nameid"
        width="120"
        label="名称">
      </el-table-column>
      <el-table-column
        v-if="['GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"

        prop="campaignId"

        width="140"
        label="计划id">
      </el-table-column>
      <el-table-column
        sortable
        :formatter="rule"
        prop="groupcjj"
        width="130"
        label="广告组出价">
      </el-table-column>
      <el-table-column
        sortable
        :formatter="rule"
        prop="disGeneralBalance"
        width="130"
        label="现金">
      </el-table-column>
      <el-table-column
        sortable
        prop="showCount"
        label="曝光量"
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="clickCount"
        label="点击量">
      </el-table-column>
      <el-table-column
        prop="CTR"
        :formatter="ChangeToPercentage"
        label="点击率">
      </el-table-column>
      <el-table-column
        sortable
        :formatter="rule"
        width="110"
        prop="spent"
        label="花费">
        <template slot-scope="scope">
          {{scope.row.spent}}
          <i class="el-icon-edit" @click="chujia(scope.$index,scope.row)"></i>
        </template>
      </el-table-column>
      <el-table-column
        sortable
        prop="dailyBudget"
        :formatter="rule1"
        label="日限额">
      </el-table-column>
      <el-table-column
        sortable
        prop="but"
        label="cpc数据"
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="customPayCount"
        label="自定义付费数">
      </el-table-column>
      <el-table-column
        sortable
        prop="zdyff"
        label="自定义付费成本">
      </el-table-column>
      <el-table-column
        sortable
        prop="addDesktopCount"
        label="加桌数">
      </el-table-column>
      <el-table-column
        sortable
        prop="zdylh"
        label="加桌成本">
      </el-table-column>
      <el-table-column
        sortable
        :formatter="timerule"
        prop="reportDate"
        label="日期">
      </el-table-column>
      <el-table-column
        :formatter="rule1"

        prop="xe"
        label="账户日限额">
      </el-table-column>
      <el-table-column sortable prop="createDate" label="创建日期">
        <template slot-scope="scope">
          <!-- 使用过滤器将时间戳格式化为 YYYYMMDD，如果格式不正确，显示错误提示 -->
          <span>{{ scope.row.createDate | formatDateOrError }}</span>
        </template>
      </el-table-column>


      <el-table-column
        sortable
        fixed="right"
        label="计划状态"
        prop="pauseState"
      >
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.pauseState"
            :active-value="0"
            :inactive-value="1"
            active-color="#13ce66"
            inactive-color="#ff4949"
            @change="changeSwitch($event,scope.row,scope.$index)"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        width="170">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="text" size="small">设置时段</el-button>
          <el-button @click="edit(scope.row)" v-if="dingshi" type="text" size="small">日期</el-button>
          <el-button @click="edit1(scope.row)"  v-if="xiane" type="text" size="small">限额</el-button>

        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="修改日限额" width="500px"  :visible.sync="dialog">

      <el-tabs v-model="activeName" @tab-click="boo" type="border-card">
        <el-tab-pane name="erqi" label="2-7不开启" >
        </el-tab-pane>
        <el-tab-pane name="erba" label="2-8不开启" >
        </el-tab-pane>
        <el-tab-pane name="erjiu" label="2-9不开启" >
        </el-tab-pane>
        <el-tab-pane name="ershi" label="2-10不开启" >
        </el-tab-pane>
        <el-tab-pane name="ershiyi" label="2-11不开启" >
        </el-tab-pane>
        <el-tab-pane name="ershier" label="2-12不开启" >
        </el-tab-pane>
        <el-tab-pane name="sanqi" label="3-7不开启" >
        </el-tab-pane>
        <el-tab-pane name="sanba" label="3-8不开启" >
        </el-tab-pane>
        <el-tab-pane name="sanjiu" label="3-9不开启" >
        </el-tab-pane>
        <el-tab-pane name="sanshi" label="3-10不开启" >
        </el-tab-pane>
        <el-tab-pane name="sanshiyi" label="3-11不开启" >
        </el-tab-pane>
        <el-tab-pane name="sanshier" label="3-12不开启" >
        </el-tab-pane>



        <el-tab-pane name="first" label="全天开启" >
        </el-tab-pane>
        <el-tab-pane  name="second" label="七点后开启">
        </el-tab-pane>
        <el-tab-pane  name="second1" label="八点后开启">
        </el-tab-pane>
        <el-tab-pane  name="second2" label="八点半后开启">
        </el-tab-pane>
        <el-tab-pane  name="second3" label="九点后开启">
        </el-tab-pane>
        <el-tab-pane  name="second4" label="九点半后开启">
        </el-tab-pane>
        <el-tab-pane  name="second5" label="十点后开启">
        </el-tab-pane>
        <el-tab-pane  name="two" label="十一点后开启">
        </el-tab-pane>
        <el-tab-pane  name="two2" label="十四点后开启">
        </el-tab-pane>
        <el-tab-pane  name="two4" label="十六点后开启">
        </el-tab-pane>
        <el-tab-pane  name="two5" label="十七点后开启">
        </el-tab-pane>
        <el-tab-pane  name="two6" label="十八点后开启">
        </el-tab-pane>
      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog = false">取 消</el-button>
        <el-button type="primary" @click="updateEd(form)">确 定</el-button>
      </div>
    </el-dialog>




    <el-dialog title="修改开启时间" :visible.sync="dialog1">

      <el-tabs v-model="activeName1" @tab-click="boo" type="border-card">
        <el-tab-pane name="first" label="长期投放" >
          <span class="demonstration">开启日期</span>
          <el-date-picker
            v-model="value3"
            type="date"
            align="right"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-tab-pane>
        <el-tab-pane  name="second" label="指定开始和结束日期">
          <el-date-picker
            v-model="value1"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            @change="chooseTimeRange">
          </el-date-picker>
        </el-tab-pane>

      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog1 = false">取 消</el-button>
        <el-button type="primary" @click="updateTime(form)">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改日限额" width="100%"  :visible.sync="dialog2">

      <el-tabs v-model="activeName" @tab-click="boo" type="border-card">
        <el-tab-pane name="first" label="不限" >
          <el-tag>不限制任何额度</el-tag>
        </el-tab-pane>
        <el-tab-pane  name="second" label="自定义">
          <el-input v-model="money" style="width: 30%" placeholder="请输入内容"></el-input><el-tag>元/天</el-tag>

        </el-tab-pane>

      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog2 = false">取 消</el-button>
        <el-button type="primary" @click="updateEd1(form)">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改出价" width="500px"  :visible.sync="offer">
      <el-tabs v-model="activeName" @tab-click="boo" type="border-card">
        <el-tab-pane  name="first" label="自定义">

          二阶段出价： <el-input v-model="money3" style="width: 30%" placeholder="请输入内容"></el-input><el-tag>元/转化</el-tag>
        </el-tab-pane>
        <el-tab-pane  name="two" label="一键起量">
          起量预算： <el-input v-model="moneys" style="width: 30%" placeholder="请输入内容"></el-input><el-tag>元</el-tag>
          <el-button type="primary" style="width: 20%" v-if="qiliangcode===0" @click="SendOffer1(form)">开启</el-button>
          <el-button type="primary" style="width: 20%" v-if="qiliangcode===1" @click="SendOffer2(form)">关闭</el-button>

        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer">
        <el-button @click="offer = false">取 消</el-button>
        <el-button type="primary" @click="SendOffer(form)">确 定</el-button>
      </div>
    </el-dialog>





    <el-dialog title="批量修改开启时间" :visible.sync="dialog3">

      <el-tabs v-model="activeName1" @tab-click="boo" type="border-card">
        <el-tab-pane name="first" label="长期投放" >
          <span class="demonstration">开启日期</span>
          <el-date-picker
            v-model="value3"
            type="date"
            align="right"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-tab-pane>
        <el-tab-pane  name="second" label="指定开始和结束日期">
          <el-date-picker
            v-model="value1"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            @change="chooseTimeRange">
          </el-date-picker>
        </el-tab-pane>

      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog3 = false">取 消</el-button>
        <el-button type="primary" @click="updateTime1(form)">确 定</el-button>
      </div>
    </el-dialog>
  </div>


</template>



<script>
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
import {excel} from  '../until/excel';
export default {
  data() {
    return {
      timetop:'',
      dialog3:false,
      offer:false,
      form:{},
      xiane:true,
      activeName: 'first',
      activeName3:'first',
      activeName1: 'first',
      value3:'',

      dialog1:false,
      dialog:false,
      dialog2:false,
      valueFlag:0,
      flag:0,
      userUalue:'',
      isDisable:false,
      options1: [
        {
          value: 'xiaobai',
          label: '小白',
          children: [
            {
              value: 'xsyd',
              label: '小说阅读'
            },
            {
              value: 'fhxs',
              label: '繁花小说'
            },{
              value: 'hutao',
              label: '胡桃小说'
            },{
              value: 'nyyxs',
              label: '念有云小说'
            },{
              value: 'shengmi',
              label: '生米'
            },
            {
              value: 'feimao',
              label: '肥猫小说'
            },
            {
              value: 'mtjc',
              label: '梦享剧场'
            },



            {
              value: 'mrqy',
              label: '河马阅读',
            },
            {
              value:'qexs',
              label: '企鹅小说',
            },{
              value: 'dzff',
              label: '点众付费',
            },{
              value: 'qkdj',
              label: '趣看短剧',
            },{
              value: 'qdxs',
              label: '趣点小说',
            },{
              value: 'ssxs',
              label: '松鼠小说',
            },{
              value: 'pfcx',
              label: '赔付查询'
            },{
              value: 'czjc',
              label: '橙子剧场'
            },{
              value: 'fxdj',
              label: '飞象短剧'
            },{
              value: 'hmxs',
              label: '火苗小说'
            },{
              value: 'klks',
              label: '考拉看书'
            }, {
              value:'zjsk',
              label: '浙江速看',
            },
            {
              value:'fjsk',
              label: '福建速看',
            },
            {
              value:'modj',
              label: '木偶短剧',
            },
            {
              value:'jhcm',
              label: '嘉皇传媒',
            }, {
              value:'xgjc',
              label: '星光剧场',
            },
            {
              value:'fhlm',
              label: '繁花联盟',
            },
            {
              value:'zxyd',
              label: '紫星阅读',
            },


          ]
        },
        {
          value: 'xiaobai',
          label: '奚琪琪',
          children: [{
            value: 'xqqqexs',
            label: '企鹅小说',
          },{
            value: 'xqqhmxs',
            label: '火苗小说',
          },{
            value: 'xqqhtxs',
            label: '胡桃小说',
          },


          ]
        },
        {
          value: 'xiaobai',
          label: '黄祥舟',
          children: [{
            value: 'hxzssxs',
            label: '松鼠小说',
          }

          ]
        },
        {
          value: 'xiaobai',
          label: '陈慧',
          children: [{
            value: 'chssxs',
            label: '松鼠小说',
          }

          ]
        },
        {
          value: 'xiaobai',
          label: '王行',
          children: [{
            value: 'whssxs',
            label: '松鼠小说',
          },
            {
              value: 'xsdq',
              label: '小说大全',
            },
            {
              value: 'wxqk',
              label: '趣看',
            }


          ]
        },
      ],
      options: [{
        value: 'DAY',
        label: '按天汇总'
      }, {
        value: 'HOUR',
        label: '按小时汇总'
      }, {
        value: 'SUMMARY',
        label: '汇总'
      }
      ],
      value: '',
      level: [{
        value: 'ACCOUNT',
        label: '账户层级'
      }, {
        value: 'CAMPAIGN',
        label: '计划层级'
      }, {
        value: 'GROUP',
        label: '广告组层级'
      },
        {
          value: 'ADVERTISEMENT',
          label: '广告层级'
        },
        {
          value: 'CREATIVE',
          label: '创意层级'
        }],
      /*
      小邱
       */

      modj:[
        '5c8274c3669bebd1daff',
        '6e667f3d41baf2558609',
        'd9532640b51ea8679927',
        '09bfc4f79bc7ab5266db',
        'fb52572c7bb80c7be7b3',
        'a55cd95d0e13548edcc3',
        '926ca248069a653f16d3',
        'd4c37a1ef4a475870ed8',
        'e09cf8760213a34fccb7',
        '100365a6950c285d2302',



      ],
      xgjc:['f10da5d17be36f05d56a',
        '3c6e43634e3f3c84ef0a',
        'c77a14dcbd9ca39f1212',
        '6dce85765c6b68215492',
        '17406c47d330aa6bed60',
        '3be62066e5426efbf96e',
        '8c3faad14679550e0c96',
        'd88cb764c91500e6676c',
        'ec3abf2004c848a358b9',
        'b293e91d7e647ec29af9',
        '0a8fcc5c49ffb3eaac19',
        '48402a1a01c7f680cfa9',
        '04479ae42d91f7a5842d',
        '8268ee32f467435169f8',
        '924a2986c4e9005a6833',
        '60cf8e5a6c9cf8664344',
        '088244e41bd37b4d62f3',
        'e57c38d231eb99469cf9',
        'c7705aa08e2b88d78564',
        '8821e2e5179df8063e54',],
      xgjctoken:[

        '3a2dc6872c899601a2d5b470cdf797284007eebce43e275e85dc484ed03d0aa5'
      ],

      jhcm:[
        'c12ceb103ca10929fd84','210044931094029aa313','0f43fdaeb51ab4b1d0e3','25e642008213def5eaa4','ed79d501e7a3f9a6c268'

      ],
      jhcmtoken:['6965266afe9d0da5b242c9e9ce53605d7e6a23acbb21d74a047d31c4d03e1559'],
      fhlm:[

        'cdf13b5a89e7dcdec123',
        '29359d339e45c1795be1',
        '533d4d592dfe55aa83db',
        '2a8648521539ebcf37f9',
        'cca0dbcbcdd23d2775d1',
        '34238af10264ce679825',
        'e6fbc0d7c3fd09d796d3',
        '43d6c889cac0b565d04e',
        '7a9bcaef3e3047c8eca5',
        '8135d11249efcfce49b2',


      ],
      fhlmtoken:['b8ba43ee06cd64c75274034c03e7b4f84a35c2cdd52a8a595bee1d1f1eabf4ad'],
      zxyd:[
        'ff3e7540c87af4754476',
        '02cea0bc0687851d0e7c',
        'fc5603654d7ffd982256',
        '10e6100d43a990337b19',
        '5dd0856bb33ef005ed2c',
        'ca51ecb5b4f0560c4205',
        'e2cef3be3e610115c713',
        'cbf514def0cca3859f74',
        '944ecf9ff6124e65f3a8',
        'a241df2a2fb5dee7bf4b'
      ],
      zxydtoken:['0b0af84e6824da7c3e15bf9b0d47fd4a286e5c1712b3a59a09a1fee749af0e31'],
      qkdj:[
        "e19270b0f1aa5978a2f3",
        "a4b8152de54a2a4a8a5d",
        "c7221c19b7fcdb590e00",
        "066ddfa94cba484dc36e",
        "e32114ab27173dfae065",
        "4efbff41b9c166c56cfd",
        "027726055c2771e73558",
        "13c019edb8ac750c8940",
        "2ab9c70e82c9a8ea737a",
        "c79a39c9c05131817b1f",
        "934dff2232b7e808d317",
        "1d720d43c0e807546651",
        "d0209aad66fbe5581052",
        "3e48bf2617a49f3584ea",
        "8987f15badf96e150644",
        "2d4b844413c2ad9696bd",
        "ac5b171c1e0fa6e31b3c",
        "3b00daf016a9dee347de",
        "7b6273b7bd559c54c0f3",
        "8540b32044ff1be97876",
        "763e1ac86b1850c1585f",
        "f11af23af107cbb5abf0",
        "61f363a78c9497c4cfc1",
        "8ad2f23a6bd1f50c7512",
        "d1f80159fca32899af20",
        "a880712814bed9ef1fd3",
        "fdeed9d0cfa057aa4e30",
        "28b656aceddfc5145026",
        "6fc25629e12d2134a834",
        "2168c02b0286e60beb29",
        "38114af2a9acd739ddf6",
        "69a2cf56674ce0ac7ce8",
        "34557a271ff05a709187",
        "25758d1c52c83610b9ce",
        "58aff50b44301476a532",
        "066dbbbeccc6c7c6f015",
        "af400e79d9ac5baeed5f",
        "3f7762529b3ecbbeaeee",
        "738fb35906f7de3eac6d",
        "ec62bbe30d33203fbf4c",
        "00c97b7c4614a18dd9ae",
        "acfb1d7a8a0c4cbf7621",
        "cf16b0ac17234e465113",
        "d94ed43a8224dac2406f",
        "3386f46636fd3b348698",
        "2d29f2758b29e4c3ba41",
        "406e0d96eac4da579fef",
        "ea3961a6a68f903269a3",
        "7ed18ac21ba9596b756b",
        "1f0893f665689e10ba93",
        "aec10990f9854a0da4dc",
        "eda5e55848f3b87b6925",
        "53fc2c1077ed39b5acd9",
        "2e1b68b010c92da3d377",
        "ce4857689cbe135911d7",
        "ca2563700f2c61642769",
        "2f80ba2dc99436ded0af",
        "e42073653787072b11ae",
        "14070b2ad3578de71f6d",
        "09fc430c4271571334fb",
        "3344c7bb7ba81d7f95ca",
        "dfa49917f3c0e36faf7c",
        "5b4997a650d0828b4f11",
        "22334f9d0c159c8b8522",
        "ad0ba37c4867e5bec13c",
        "262258fe75eca0a4a33c",
        "a6104e634bc2b2bbb88e",
        "3357f60121be29109351",
        "b5b3ecd6c083924cc2d2",
        "c7b611f9adcc6e734e86",
        "61ce40d5e628b0f46a79",
        "13f57005680453a3f54f",
        "377353680e2836c66895",
        "25a4c37470d9a008df4e",
        "4b228bce6811d2454fb4",
        "61172e2ff8e92fc31840",
        "7ed396a3ec975e3df39b",
        "988626da96c8d0a83097",
        "bfa0e6a8b05420014b4f",
        "59d06f8f2e92534ee920",
        "9b7e5cc4e1245aa9de4a",
        "9572d6f348e83ca70b2c",
        "c62c62b2a41a6d717276",
        "9fe48f27303bfe2f6c7a",
        "a83d50ac7d54ee0ac890",
        "7c6c99db3fdb8c7899dc",
        "841bbbe11a3ee3c0dbc0",
        "68a23f67c68d0258d8be",
        "4fff45db5564e712e0d5",
        "b4ddd1f8fc9375fae9d9",
        "09cd684285871f16ba1c",
        "6b824c36a9cd1be801a5",
        "f16de02885b91aee7eb9",
        "a123b7d67cb6cab23f5a",
        "a20406432dda8182d0e7",
        "2e889eb1a883a0b38dd7",
        "d6835ed111c9b45c20fc",
        "f682b2b695de4a4877c4",
        "d254e634ff2a7514b7de",
        "b1a0d98825b583f16870",
        "fa2db9e9ff41713349d8",
        "ee58d2b2c70e89445b96",
        "e3f0e2b402fd38ea5932",
        "0eadbc6f4a75b124d0ad",
        "366bd96aa29ff70e9fd3",
        "e2f1ff242911740356c6",
        "ca73d55dcb71aefb9324",
        "ebac1ff15f2171ae058e",
        "686f40daed51b857a5b6",
        "15a3c231630efd0965d1",
        "2e91a29d29a8de8a45bb",
        "0ec56066690dd917adfc",
        "4749ccd3dc9f38cb8b9a",
        "da6236bc2ae2ce774784",
        "90540fc9917971b8f1eb",
        "0ecbd4d5380d418e5668",


      ],
      qkdjtoken:['be3396a6ff8f1fe78fbaa9973b788ddc2a289b76f843410084a4dbffae0ce732'],
      qdxs:[
        '4605552770ef53578411',
        'cb7d4959c7432f80fc0d',
        'aed523ac747210d3b37c',
        '3462972c4a2a69f925c2',
        '7cb742acaa3fc9b6094b',
        '33e67b0082834fc83dda',
        '4e86b405955c27afb07c',
        '4aab11acba4eb3fe94ad',
        '0f6bac77bb62d215320f',
        '9c03bd8c80aa9c8e7232',
        '5a04df046e3e16165f0d',
        '69ecf51c9d74bbf83768',
        '68616479d201b9a6e195',
        '109abef9062bc460cca2',
        '50d52e44372cd8cfe5cd',
        '9874893f836feea31445',
        'ae81e3ec4664d70eda3b',
        '7ba4c3abcaebceab508a',
        'bb60d6c7bcc97bfa785b',
        'a4532cd159d55d51d6aa',
        'e9d683f820c34eb40c0e',
        'bc6a9afc3d37a0fcc40d',
        '862731d00f80ac28f350',
        'aa68dd9db767a28b7feb',
        '0350deb58ec2b7e5a668',
        'f564bc640f9b61f65a7c',
        '37c917622dd0eee60b62',
        '05b70b2559265638fd16',
        '8035a004d1417fca7126',
        'f209c6cfd6f4fd171959',
        '0af50dc2a9ba62e0810c',
        '51cbeb02ff5086e19fe7',
        'c8f28cc8518224a198df',
        '65aa04820840328d2b0a',
        '88dece34fee623bd7b6a',
        '42cc004f9c6fd407b99c',
        '447760f73772a84d64c5',
        '10ce160a3106948bee83',
        '01b655342122b0808a2e',
        'dcae4fb481fdf0bcb84b',
        'db3d2f1752f18150f411',
        '614dce879ea78e80e520',
        'ab55b4d34a70ff38b5e7',
        'be153c936f36fb92d563',
        'eab893dcbc0b00d6dae6',

      ],
      qdxstoken:['19160b355d135f2bf81d75507b278702281919d130c1b6b6cc08ea6c5b1862be'],
      modjtoken:['29d59c7ddf734ef6f4c9de4b882e946a60f31aea5b76cb2695ca31e8261a832c'],
xsyd:[
  '3a05d5cac153d5b5b571',
  'ef1e9dd19a7e2a8032ec',
  '148a2efcf4879ba38af5',
  'bdd824d56bbea47fc65b',
  'f6d88bd2c9719316560d',
  '28b51cd8e5ee6327ec72',
  'a055e6752b07ef3300a2',
  '437e3946fdafd9ede973',
  'd4bb90b68f98683916e7',
  '7d608c73a8987e675029',
  '88fc3e8f765e2b87a207',
  '52276fd136347b4edf66',
  'a11b2ed9500dd08f3ddb',
  'f2128ac42f59b8fda7e7',
  '708be4276cbb5ae41e58',
  'c6fd67318839cbc8fcee',
  '989aa40dbfe6c71cc1d6',
  '033a19f4f895fb528900',
  '4137708c4951863f9f03',
  '44caf3309242e7e25f2c',
  'b14dde881a82e006f4d3',
  'fea96ef90ba1946147bd',
  '4b7461e5ad916922ce61',
  'c0315181fecb466064cf',
  '4c16c03374d9f946e569',
  'ecb6d5f28f9e19fd4616',
  'ac1b44fc025d90b53329',
  '032ee826befeb9a7e784',
  '0f1a63c8c7e67e5729a3',
  '11b1e0d3aad66ecb6136',
],
      xsydtoken:['0fb4afee15f7be9f1721fdd7542a7f0e4f64fca5c42eddc50b570cb60ca3c6b1'],


      fhxs:[
        '9a4ed5f3c9630944dcc9',

        '08948a168edb21639a2b',
        '32fdf03929414c201eb0',
        '04a5000ea31207ff280d'
      ],


      fjsktoken:['66bb2ed65ecacf5596501df47ff186eb9a3bafa160a1cf40fdf293b6d9f72be2'],
      fjsk:[

        'cbe8f3320c6b471bc336',
        '39707f5d389d17db9bfe',
        '93b5679cd0993499350f',
        '1f0dc61ec0ee79cdf956',
        'debbd6151ce5c0de6903',
        'b3d83635899ba3ec1713',
        'b1f0b7b2c5e180b23725',
        'ef7a6b73775d2f56b603',
        'f25e0199d1a6686901a5',
        'c733980d03cdfa8ce8ab',
        '22473a5a91f3100001d9',
        '26b8f2be8a06b105d6db',
        'b65cfd3462ba5979e79f',
        '07e30e6f35a8fc29b26e',
        '89e0f006265feb5cb909',
        '187c0e55884bee09051b',
        'dc358e895caee2a64174',
        '3138999731d821602216',
        'f7eb9ea6221d600829fa',
        'db247daba041f66c7657',
        '11a11464f624b6a6be05',
        'a31658aea4329b764e6f',
        '137ebd83f29d5c57ebc2',
        'ff08d0f6bd189e65153f',
        '555c1a57751b8297e475',
        '075bb53c2b4da40ef3d2',
        'ebf270f674207038c5e5',
        'd2f0b9e9a4739173a6cc',
        'f8095f711f8b3536da4c',
        '6a81c1105e4d23badc43',
        'be8c5775a0ab69237c35',
        'a62bcf8b7489c2688868',
        '498544b2ce55bb2b6f1d',
        '525b28a4ee5f565fa7ed',
        '9b8506f57eab0d96c492',
        '93da5afc4a3a503bdfe4',
        'bd394e5d7457194ec8b1',
        '198b9636ff0bd5f290e9',
        '30b260a60d0c73a6c709',
        'b4e8aada4bd47951461c',

      ],

      czjc:[
        '7bc1ab1bfdf98078c213',
        'f54962e7ae522a29893a',
        '46430c67f9ff1f0d1e5b',
        '663dd3c16aa601d487d1',
        '303bf33d57ee5bd82a58',
        '17868a09c67580cb8702',
        'a97c524b320fba2a36aa',
        '34de88286731dff2a23d',
        'bb21dfcd9496d9e3910a',
        '89bbf39c8c521386371f',
        '333326231714ec6971cb',
        '185960831376469ae401',
        '250d34850f22409bb533',
        'dbdcf47af4e712ade506',
        '5e3dbd77461923b45e7a',
        '49096d71d527896de47f',
        'b479ca08181d9b9ef013',
        'a11a0f45a2d484333012',
        '69574359505f73bbe628',
        '5acd91758711eefb1cc9',
        '9a18b9b0674f9f46ecdf',
        'dffa9c6fc20e96a96d00',
        '847d5cd1609d07833104',
        '6e17cd07384cfc1da126',
        'ea4870005279526cf94b',
        '88caa819a8ef989fa1e8',
        'a066d47e1730d59f79b8',
        '8041136b5268a59a8452',
        '00bce5b9b92c8b4be3ef',
        'd42586bf17a3087d3054',
      ],
      czjctoken:['1380e514e982e4eddab86461a33fb181a084d913bef83595efd107a809a962c5'],
      fxdj:[
        'e44b19ba5dfc73ae8fa8',
        '389ffa5159b00ed83f03',
        '04ab3b14b8b484e1fc9e',
        'd0f8d56652057d8f5ce8',
        'dbdf0085e756bc1cff80',
        'a7805e0ef98c340785ac',
        'b3f0aefb5469e3a71c78',
        'b3f0aefb5469e3a71c78',
        '769b6949b6037614c9ee',
        '2a627e458fb8f8c4a08f',
        '06af970531d8448de452',
        '4ef1cd6f59c9734c66e2',
        '671ab9c63948c85334f8',
        'c4278796e583788c5a53',
        'e402a127da216d3bcfd5'
      ],
      fxdjtoken:['45a508809971904f0c3e7f8149f3034c7ba3685ed6d4112733066ccd96fc6bd6'],
      xsdq:[
        '32f7487674bf359e4698',
        'a6cfb236bf69b27795d6',
        'dce27552b989a48d5301',
        'fccc5273e9af92732dee',
        '55d34d6a27442ad88a5b',
        'ddd77abdca001d28d344',
        'f2ea50db48cc20fd8d42',
        '4b38815649a7137853de',
        '9e6b8528b6e7aa3d947c',
        'fb839a3fd6e59c0d8ef1',
        '6afc05bd638ef88c8d3a',
        'cea1564a5670bbb2bdf4',
        '91c4a087917393952b4b',
        'ace326dd9e83f2c3df05',
        '9206f410432b9acee4db',
        '76da773680cde3b5959b',
        '5fa3641b196f470892ad',
        '309282a38fd3c3fb8614',
        'ccfd822e14ff9439093d',
        '25f8149f4b176b1785d8',

        '4679e2372cbd6f282d02',
        '7487d4adf0f1150e6a4c',
        '43be109978ff23062dd1',
        '7f877881bf127dcb1208',
        'c3e7c4b67f35f0401a7e',
        '0c0346a4580f9c6a01e6',
        '229ae0422406a0351e76',
        'b5f39fb15ae928ec0e58',
        '5ff318ee9099e15bf1fe',
        '6cef77ac3e2290eac853',

        'ba7acf33a20e1cd843b1',
        'fb3f31c3abe222a92b71',
        '8d17e67da68fd8c93d92',
        '0a7a8afee9d904feea2a',
        '627dbbf5d7596e89f944',
        '59531fa4481fd18febb7',
        '2d66bf30a1c88af8e6ac',
        '6a8d2dde74cdda1eb774',
        '5d9b3ab2519bb2ad1ce8',
        '8bf91a118ebbd2715077',


        'b041662c031a309d0e39',
        '80ce4df7ca31e3177dcc',
        '69c91de1c308dfbfc14b',
        'a2311934748bd4e6b5c6',
        '84f19a0a7d87f00ad7bf',
        '8672b595bea2a309fcf4',
        '02003d16a3f7b5ac5d20',
        '7dfdc06bd8c1afc76263',
        '69c98576fd993f7b54c1',
        '17710431f8eafc2e8a79'
      ],
      xsdqtoken:['0fb4afee15f7be9f1721fdd7542a7f0e4f64fca5c42eddc50b570cb60ca3c6b1'],


      wxqk:[
        '75761e8d0f145ed76e9c',
        '9f573f70222884f74af7',
        'c568d6b4c9da72b123e6',
        'bae2b9bd3e67b978e4da',
        'c66bcc773e689e99776e',
        '1a04013ecef833516313',
        '0074002aa81a21f6ae23',
        '42deb66e023f52b612cf',
        '2f4e00d3b44c4b9a407b',
        '3efdcc82101541ff96dd',
        '92ca444492595b1708ec',
        '07fe5ae69db23e5e3fb3',
        'dc6848b41f335f76101a',
        'a8d9cd4d42288bd726b2',
        '74bdc50971e68363a1c0',
        'f530f4644c8bc45d361b',
        'f1b3fec24f07b528fd43',
        'ac9dbb357917d1196e0d',
        '71793567a8d667d73551',
        '967b734901b49156c505',
        '92f44632df4f0bde4eb4',
        'b6dc2fbbc9421062f86e',
        '551003ec9eb6ae6b59eb',
        '7339d16b7c7cba56c78b',
        'cef5562ef2268fa3bcec',
        'd32b8779e7fd5f444760',
        '5e5286354ff46a76b548',
        'ae47caf5d34f45dd9c6f',
        'd17b52e32e33fc01845e',
        '1380efcca1149f6ecfab',
        'd1d0c8ab383d12a6f40c',
        'ab43d583085c25a09094',
        'e60725cc7fead872710e',
        '50866e0fc505e8e01ca7',
        '0a4aea16cbaf940cfb8f',
        '0d622f7a724a76903d44',
        '8950156293600a7469d6',
        '2fc6037b136d15665270',
        '8add02802cd4c4beeec3',
        'a5a3d1b3969d418b9a48',
        'fdfe457dce840664fc8a',
        '1aed65bdd6754cc13a44',
        '7441b42dec5f03ec390d',
        '7940b8bab3bc936e72bf',
        '389fd1a54f0398c02e76',
        'd5f7080d03e3367b725a',
        'c7b6becd25ec8b25de03',
        '07f22d9271ec39561e24',
        'c284a6490e3d24d37e01',
        '59d27f8567e57fea0219',
        '1cc2d6ff510897a977ff',
        '5249944669f7d83d8113',
        'ee8be1e4ee17c2c3ea24',
        'e57ada722c5d537419aa',
        '0bc723a7ff4e03086e69',
        '44e63c9e3fb8d90e4384',
        '3a92fa7111846a3caa4d',
        '9090850519753dac15ee',
        '4036e643a95523059c8f',
        'c934cf0e9326041738f7',
        '1cd419fed6b52a8b5a40',
        'bd9b36a07c1f0d9bb26e',
        '44cae2ba18621b75b48f',
        '01a0b449558531057489',
        '3d226e1a457d37aa8d10',
        'fa4109d0b481ad5cd871',
        '852fa3576fbe2028d94f',
        '29710863487d2ead8a6b',
        '58b839fca96e430b9d94',
        'ab2211fc773d0a886baf',
        '212a29739883c24826e1',
        '6ad372f3b32e2e716be5',
        '889c8d91b9a65f1108ce',
        '3a8617c2c4a2c22d4710',
        '39a7c16c303b3a99ae52',
        '8619ca6526c4e6db8fdb',
        '8c6bcb9979c09461f301',
        'b55c252e4df8828b80f2',
        'e7684a0ee9de56251cb3',
        '6428dd5696cd144a2550',
        'bdcc8ec8296bc9abdaf3',
        '5bd70c7ecdb8e61964eb',
        '6d6bbcee2f1c625fd49c',
        '3661e386142963d3de91',
        '44d28a9d6480fd9003fe',
        '6e442e8733892a14ae1d',
        '1ad87da2dde1b97b0b81',
        '6f6584bcf0962d1be21a',
        '6c24ecdcd4312cde62e1',
        '1496dda3987b76be85a3',
        '28050281ea3ef276ebe4',
        '8826503b02fdab5cd740',
        '03285e47bc90f5e998dd',
        'f3e8078efcf13e0b5cba',
        '2a9ab1c98eb559b9cc19',
        'a08a3efac08178501fef',
        'f2d49e213b738e3bff02',
        '3571d497c0b7b53d0e19',
        '9be767450b98a9c84625',
        '968bf12649dddc7c9618',


        '9f2914e2c06be57dac68',
        'c95dad51b33a53f22cc5',
        '157193dd8dc71340664d',
        'f19b0ea3e0f046ff43e8',
        'fc93723c65fa4585f977',
        '9cc64db5fee9ca0f50f7',
        '97df8d38f6f80dc57821',
        '04570c7578ad82e2ed8f',
        '6a0733f4e77e68a6c905',
        '6a97c9faa768f71b8818',
        '67f3728774be126b1f86',
        'd9b41c6a881148e9a067',
        '1080687f4fb579e653a3',
        'ac7e7eb08da676214bff',
        '29764c8d342cb54eb1ff',
        'f53abc3629616d882b42',
        'a12d97b1a371fa4e72d8',
        '4ab9d7dbc431e8608bed',
        '30c1ef983310d623af07',
        'd4409061793930d746c7',
        '64337ca7ab7da3e36bdc',
        '1cf19121171c7e255ac4',
        '66939b15d173991ec115',
        '9fbef5d45820fbf235bb',
        '630baf317b191b90d38b',
        '9defea6011ea9d13a8a4',
        'c573ca606c5914dfd449',
        'cfa740941696db6c0391',
        '37d742b07b241bddb05c',
        'd79f68b4b739119e5479',
        'a57d1566a7c4175fa164',
        '236b249c012c9f67215c',
        'ef6e009247f5cf0cb669',
        '9fe30191354134e3131d',
        '841727faa1d25dd5ac42',
        'f2dc2354d316d1276da5',
        'd81fec89cbe385dfbbef',
        'c502a5e4296b50234333',
        'bfefca6b69b0187a5dae',
        '74bf6020225b4fec343e',
        '2bdaadb1d54465148bc1',
        'ada2439036cdf5664310',
        'c7ea027dbc676f3695db',
        'ea1ce16da7eec6bcdec3',
        '6de4c95494c9640e25ec',
        'c96687ba2489434bd746',
        'e3bff9bcff0de7f83059',
        'dbda1cada5f1ef394855',
        '2621aba444e9d414f8c1',
        '9cd0c0a22c1066791680',
        'a49a23c60d9c8bd377b1',
        '42969309845d5f0c52b9',
        '8a2a7c0315de10f6910e',
        'b6732620b063a0d6b3ac',
        'ba6b9907d3264636e4f0',
        'a4e6a8d76a26f2cbf0b9',
        '647fef092701347ec7d9',
        '868b93e8107867a48adc',
        '710ed535b555820e44ce',
        '84ec492552555c763bac',
        'df47a48579e5ecf39f27',
        '59f1ea6cbb44d49fcd61',
        'd7d867de0c1b33a779c1',
        'a8868ec01fe90b62870a',
        '970c7a255506e8a6e902',
        '60ce77e424fe2b3d9568',
        '973460e80508232455d8',
        '3f21718b15d743cf8391',
        '4f0a3ac868d93ef7c139',
        '90df614d4af60f2029da',
        'a27d838091d86ad40bfb',
        'ec0ef51eea9453c31e90',
        'fd41eb1794bffca10b0d',
        '7a1f94696b1bc3534617',
        'daa23839ef9334269dba',
        '4e55e41d34ac72e19afd',
        '92c42f58598fb81d1dc2',
        'cb64bc476e35053ffb74',
        '0388f838d8eb38c11fe5',
        'e2832325b41e688b2fcd',
        'faddb7e56762b451a5d8',
        '6d3442c373efbe8f2761',
        '641047c0a6269a229312',
        '745aadff2c80f558d2bb',
        'efb0d3b8f22be9d431df',
        '973df2a930df1214b8ed',
        '51f6dca40934b16975c8',
        '8f77672f95aa4c6a80f0',
        'dc7a4736cf0c4a12906a',
        'd1116cb08bfc30f8fc03',
        '5f5b4720a7b77501c10f',
        'efa18f1605e8fb6cf4f3',
        '66f6c0a4aa8545370b6f',
        '7776b1e294c60235c84d',
        '82832ec659c4fb4dd9df',
        'dd2b1ecfb9f4c1aa6f2d',
        '3056637e03cb24660d9c',
        '375cb274ddc9924a3b94',
        '3c33c8f1d28d053e1fa4',
        'eb05972857238475faed',

      ],
      wxqktoken:['a665302ca0b4746559f6ba8740eae86bcae1d564d52b46e94fdcda40a221ab2d'],


      pfcx:[
        'ae62c945876bb675827d',
        'b733f0346e424cbfb970',
        '05c0c2d57d9054894e8b',
        'eb9fb94b5070d5dd4ff9',
        '49f343a507a1a5d98b8d',
        '725ac3656559f2c04b18',
        'a5b7de79a03c14217a65',
        'd2ece63d2ea1be2d9456',
        '94ec03f3a7283e693b00',
        'ce2b0cfab75efae1f721',


      ],
// hmxs:['a5a031d51f457068eee5'],
      fhxstoken:['a20b9b0ec57a9898598361684441cdf8c7a5a81ef6689140798285f9c4521001'],
      hmxs:[

        '242b696a31b23cb9b1bd',
        '51a175dd7cd74415fd39',
        'f5b9071a68a757a214d3',
        '39567a17add5812f69e2',
        '5bf5191af21b2d4e48d3',
        '03b84824f842f41e2824',
        'c5a1346c8bf5e45f3c07',
        '6cdb193a02fd8f8ec643',
        '2fe4afb611d6c6254a32',
        'cc75df9974c775353b3f',
        'd6e7cd65667a52647dc6',
        '330c282e989c85b1e856',
        '6d3b6765750a03124e1d',
        '700db50e744d0720e7e1',
        '9e4c6109e94aad9a7d0c',
        'dde9a2fcfb25f6bd963f',
        '5074960eb934161041f8',
        '089fd71cd6f51bdc4018',
        'f09c91899448f50f2a26',
        'c7be87f4a9adbb1eedcd',
        '35a59465b0e1a418d877',
        'd8cd93defce0f3040b25',
        '9f918ceecc97c65947e7',
        'dffc0130d9e3c524131c',
        '70b26bcedddc2c9bbb2f',
        '5afeeb4170e04abb8a41',
        'a240d1655b80577e380f',
        'dd272032926d474b4f9f',
        '607222f560c1cd6e7ddf',
        'b4d7d2a3aa2379645168',
        'e415c5be184412951746',
        '57e462cbc7f8b3fb8efb',
        '6d13ecaedea66279a282',
        'e017519b4b81d4bde227',
        '07efc50fa7651af5acbf',
        'dcea4805bb1f83d9ade6',
        '82146f4d18100168c1fb',
        '64fb7b283c7f1e8cd2f3',
        '82e74f816dc4aaf13e11',
        '305de1d029cbd6b07050',
        'f192e51bd164b333a7cd',
        'c3f15d00948edd61edb9',
        'f8e691369d51680ce6ab',
        '63e4c5a68df09f28fd3a',

        'b415fa428ffbd8ad2b60',

        '58c14cdc0810b4c682b0',

        'd9b90dd66f5ded6d0121',

        '6841c11b1fa641de0148',

        'e21e20eee3211d485911',

        '791eacc276ebf8b21009',

        'f614c60da50abed521da',

        '1bc1b55b00e6b1c0d103',

        'e1b3986591f2e8b88e7a',

        '6420566311d74a2776c2',

        '94d7298687e8361b90b7',

        'f4678b7761b1a39052c6',

        '7ab1e8c5b1d0a105888e',

        '84567b4141d5dcfb3086',

        'd6445219775094fa46bd',

        'c282f6e4a332ce8df19b',

        '93fa65bebba9d1fe13cc',

        '620b909dc19f21574727',

        'a5f4006c12c7c48840f5',

        '5ae4ae27d1fb9b88da8f',

        '8aa7ca742fec2d29cb30',

        '0bf6bbe6e472721ca313',

        '34527b41ccfc6a58d079',

        '063d21841f45f3790cd9',

        '9db4117e2a5c019a1a9e',

        'd35d672e9be1a2223305',

        '9edc38c2142b1824c285',

        'd0ae14c4b16ea914ce3e',

        '3386a9821dea34c5bf35',

        '6ad6b58d924421dc8940',

        '3da2fe55b966430c19a9',

        '06b0f2dbbc799711a41e',

        '643ecfd97113efb0bb80',

        '41cd63277389a2ddf9ef',

        '84988e2ecb9ab0051b08',

        '82151088bf9fa5c09a6a',

        'e9c7e803130b4d8a3c3a',

        '493408214c87b6b0c8ba',

        '53aa4b34cebd95424789',

        '31c801f49ef2a6599290',

        '2d2e1c00bfbd78d7c804',

        'be9494fc1b03ad924334',

        '9553f101124dd6a02fd2',

        'f3f0f476c3215208b5dd',

        '795e2f71670c11ed26e6',

        'a8054c6ae185571629b0',

        '149d3ff15f71cccc13be',

        'ec1b7a4f0d7e6998e9b1',

        'b50b81fc12497f9999c9',
        '2fef2e0923b04d0facc1',

        'f834159ff5377d217a8f',

        'f628c0eff40e0a21e013',

        '2636b0922c9a2d7b71f8',

        '5f86c5078c3654cbeabb',

        '8936ddb2eb522183e21b',

        'b09cd253f1fd2852d995',

        '99bd629fa8ab25bed090',

        '8385698cd8d6fee8c10d',

        'c50efdfd4b75eda13e73',

        'd2a4d03852a5bcff913d',

        '95f2c647a6f51204aee0',

        'a40efc4be80bea3f0a73',

        '886f3805379d9a11a905',

        '1e9ada22bb168d41fb76',

        '034832df114b5428694f',

        '6098dae9274c15f55ba1',

        '92aaf2de96073ee0263c',

        '1fe82e2752584814bfa8',

        'bdf1949147ebe1eaeb41',

        'e9c35cb48b91fa4e940d',

        'd2f43bfee0f6bd1ec4aa',

        'fa11398edfed6b743dde',

        'eba4c02f5cfb8b759221',

        '931a22fa1ea4da797ca0',

        '99d9f5f7f0818a9926d7',

        '73735fe6b29a9a1717c2',

        '48f0172c45c90f152317',

        'fcbe799ec35e8d55c9d6',

        'c5eaa1054182fed6f164',

        '1c570cbea758226ec6ce',

        '57853f80fe1fcd65061c',

        '4100e60fce532b9b90ce',

        '63f10253ff8d91400cb4',

        '9d1ba9e1aa26b1382e94',

        '3b2e3eef1abedf30b988',

        '0d08b9f6da328388d902',

        'a8f58309494258929579',

        '9c990ba774e0f0c77e9d',

        '454856fc01f4fbc623e9',

        'd036c33476fb7342ace0',

        'c26398258d9e64372eaa',

        'aab3b440724f448d780b',

        'bf77af326ac194c89989',

        '805f94f55759b11a5fb6',

        'eab7b6b9f78cd15041fc',

        '2eaf0e3d4909731d298a',

        '67f5f34150af74c27fbb',

        '69852a1b604ad84fb28a',

        '7a3f65160f26af1f0b11',

        '323e3c667f828a5e9141',

        '8bc37922b23865feca5e',

        '7265b2b9fdf5d342ebbd',

        'a976a28cf00d703768b6',

        '283e817387a84e5a26d2',

        '90213c98a68dc12f2b56',

        'e56d3aa976c2de027835',

        'b463e0407131205bfb85',

        'dca8cfa2e182f5da5cc1',

        '604d74d3aad928830044',

        '0c2c1d4f0795338a379e',

        '0c79aa09f65bd3e2f777',

        '4aa72c73fb86fb8424b2',

        '9a7b9534e16ce0af5f4e',

        '6b3b181c13c2f6330b7a',

        '4a88c7b794c9e6477625',

        '910d7e67857fc332577b',

        'f8de6e3b964397c791db',

        '79c70abbcd19d570927b',

        '5dafa61f3c141f835116',

        '0a5710e35054a81e3da0',

        'a1b67cb6ec8091365059',

        '0c2d59edf057d7c28fc1',

        '870847fbc6f13af568bb',

        '88bd1911f8dc45ee8dd9',

        'cd5c3eb249a1147503cd',

        'e2cb91dfd7ef1dbeb5d7',

        '26a66384acc812594e63',

        '8ef8387cdd5c0848929e',

        '81cac62844b0bef25703',

        '8ad3c9523b055126e140',

        '1a911908d9e41d314093',

        '9568f554c7eb773996c6',

        'dfabd87ffca9c0456303',

        'b0d01c3bcebf14976725',

        '368339bd9e43526b5fe2',

        '196cde6e1bf33ed67b06',

        'a44206b788e0bf7c36ee',

        'cefd77386e5477942c14',

        '7091bd98fcca731f1abe',

        'af44401bc93248794a1e',

        '614ce57ad64a824e9dcd',

        'cbaa6ce7f906ffa5e525',

        '610ccc302e6d6f02f4bb',

        'e7f9c6038ec427b656d4',

        '079f658cbb869e43429d',

        'e604cf7d8dfb9fe71585',

        '466174d64654967f20b2',

        '502ad6a235b34f97e7a9',

        'b95978040cb7155eed56',

        'e303608846d96e8117f0',

        '1c9e928988762cbebf58',

        '561d2f55e10cdf193a73',

        '0818be57d5018b249a72',

        '6619eb4c334d507d9a63',

        'ac2861d49e3545b30482',

        '975b38aed31453c78a63',

        'cabf4f72e74439c1cb40',

        '008fe2eaf82912ceb131',

        'ed45cdd8a58dc7b3eef2',

        'b7213bef753ed65972cb',


        '90d2d56fd148ae4e131a',
        '956f90cd465fb1cb3743',
        '10d82fb4c97df567e64b',
        'c10ca5e2b47081c0ec2e',
        '54dc07ed67a34239f366',
        '98a2df2364e9b143aa9d',
        'ef0d787fc628034612a8',
        'fc41aecc079a3813e7a1',
        '7bdc8523711ac5a9f712',
        'eb0a4ff8791bdbe75c10',
        '396e5b8b14807116d79f',
        '083e8d3a34f92aadaca5',
        '48da835957b04627af32',
        'b3eca6b01f7477095645',
        'c00ea68fc44196d28b76',
        '2ce502cf46d54786b2a1',
        'e2af6fb1560566dee713',
        '317a4e3294070f1fc46a',
        'a902e2e4dc693bc113b1',
        '79c8d7cde55d5fbcd2c3',
        'f06de8fa5cafd6541d76',
        'cf715b3cba453443e646',
        '0539a377fe98b522a6d5',
        '24088457edd66402ec34',
        '4a7527b7454912540240',
        '2d4feb4284a4991d85b1',
        '723f97c5873e8399d281',
        'b6de9b937e85a8fcea33',
        '2c0610ecb6e7a55df5fc',
        'e550822dd75f5f7f89a7',
        'be1b61d06075d57b06e5',
        '927c6df9320e414f080b',
        'c529debc20c647d452c5',
        '8502e73f0e4eb16bc585',
        'ca537304afa84c29f8cf',
        'f6d6d86248144bb7a0a8',
        '54f2589567a2dd296eb5',
        '26de40580686554ee35b',
        'c9b248750d62b8287b4e',
        '8e173e839c06b807b31f',
        '361d158baa7fa23f8ebb',
        'b7213bef753ed65972cb',
        '90d2d56fd148ae4e131a',
        '956f90cd465fb1cb3743',
        '10d82fb4c97df567e64b',
        'c10ca5e2b47081c0ec2e',
        '54dc07ed67a34239f366',
        '98a2df2364e9b143aa9d',
        'ef0d787fc628034612a8',
        'fc41aecc079a3813e7a1',
        '7bdc8523711ac5a9f712',
        'eb0a4ff8791bdbe75c10',
        '396e5b8b14807116d79f',
        '083e8d3a34f92aadaca5',
        '48da835957b04627af32',
        'b3eca6b01f7477095645',
        'c00ea68fc44196d28b76',
        '2ce502cf46d54786b2a1',
        'e2af6fb1560566dee713',
        '317a4e3294070f1fc46a',
        'a902e2e4dc693bc113b1',
        '79c8d7cde55d5fbcd2c3',
        'f06de8fa5cafd6541d76',
        'cf715b3cba453443e646',
        '0539a377fe98b522a6d5',
        '24088457edd66402ec34',
        '4a7527b7454912540240',
        '2d4feb4284a4991d85b1',
        '723f97c5873e8399d281',
        'b6de9b937e85a8fcea33',
        '2c0610ecb6e7a55df5fc',
        'e550822dd75f5f7f89a7',
        'be1b61d06075d57b06e5',
        '927c6df9320e414f080b',
        'c529debc20c647d452c5',
        '8502e73f0e4eb16bc585',
        'ca537304afa84c29f8cf',
        'f6d6d86248144bb7a0a8',
        '54f2589567a2dd296eb5',
        '26de40580686554ee35b',
        'c9b248750d62b8287b4e',
        '8e173e839c06b807b31f',
        '361d158baa7fa23f8ebb',
        '86334d6cd5dee0c16b56',
        'ae878d1ea88a33305a21',
        '10cd333baddb3117d28f',
        '2cd405396549a285aa33',
        'a1496e316dac707c1255',
        '63782e6b6b96330a185b',
        '4c8847f22d756b776b4d',
        '372943cab63c031a2c06',
        'abdcae5add238a1130cd',
        'c68b096c41e99ccc6aa6',
        '10aeb10ab43e959b218f',
        'eb8942f074dffd36558e',
        'cfe30d0e6fbebbafe9a5',
        '9851cd566e5a6462ce45',
        '000fa2f4fa39cb135ddf',
        '1636575809016f76aa27',
        'f691fb72ecd7a8016a5d',
        '00feadb2602d0cb425d9',
        '5ee03a75888371269237',
        '6ebf838b0c1841df3e46',
        '513803aa37c3fd99ac74',
        'c721a537c4f4a0607962',
        'a9e120145a9fb979b1ea',
        '4b89412f07935e6834eb',
        '19a500e783371b345857',
        '2c0573d55ac125374030',
        '5ab9bab8c6f62097e860',
        '5ede7e219ba437eb4e80',
        'c6976921edc11b0a1353',
        '97d7cc6eae711bf0d6ed',
        '489c9fd304d934600dc2',
        '5dbd344d11d26db0f116',
        '304146e7340876e9149e',
        '26299b55eb408440aac9',
        'ae07f72f378147c3cc18',
        '13e331d1dc28d9d81c4e',
        'b637176cf7f294507c87',
        '5b0351353f7a2e4b37c7',
        '46c42e22583edff31e65',
        'f68694839a55f1206bdc',
        '72331a20373840b331da',
        '6ec2761110f349ab00a6',
        '56cd772b16335f505f10',
        '62c15c6ea25ba0642351',
        '7869eb5a71faa8876d1b',
        'fce091963a344ac04787',
        '93fef655105e51bba913',
        'd3431fd8d323ef226f9e',
        'c3973eb2fae265fedc8c',
        '61ae13226fb73eaabe4a',
        '4e1ade5fc18c89cf2c99',
        'd1f60ec81daf1abafb42',
        '50f33be62a56c70270e6',
        'ffa66470c392eaf82af3',
        '180268c2534d684b28b3',
        '9c1f7da797d2907cdf58',
        'b60c245d2a6d962fc364',
        'd4bb0e29b903cdf9d889',
        'feaed1ca9bcb04ce0105',
        '3508ee9897079b95506e',
        '3f74f07ee209a6d17bb4',
        '35bc93dff55fc8191470',
        'c3de52b70cd9cc229791',
        'dd9dba2d84c4bc4387a3',
        'a93d9dec166174f298e0',
        '06b34d44ed16ebb2e33e',
        'afd60d7813daeb45a5a6',
        'f6f4ea661116483b0fae',
        '38350a64e793e726c2a0',
        '50456fcb8401cbd3a86f',
        'd9404bbfe03f1c36e68f',
        '458b67a8479dc8907132',
        '18f1e64e69517871a516',
        'f1e9333936c6f5b623e5',
        '83313e1904657dc40d27',
        '83a339ddcb8014b4c949',
        '43109218d4ed793fb145',
        'c7da99079b41454130db',
        'b1b102b98b5d7bd2c1f4',
        '545cefa649547416d8f6',
        '84fa5c9ca2cc3f76cfad',
        '55a33a5cfd09b8eb5bdc',
        'b3b7f01c6361c6ff1c4a',


//2023.9.8
        'd6289c2d15ce4f323ca3',
        '7e84e7a729e5b7fddfa2',
        'ab97890183ee528dc9c4',
        '3a11e01927871a4763b5',
        '5cccf4959e3897cdd321',
        '8788e9eebd824b9279c8',
        '6909014521098d22d61f',
        '99605472dbc6d364a777',
        '4f1da4fc761914eab9ff',
        '935aa8c2f13f1ee23625',
        '8666d679242d699fff61',
        'a91ee16d4d853bf66602',
        '9fce193fd8d81d258a3e',
        '4994d76a54f44e87549b',
        'ff691d5a682e1b6c77d3',
        '7b805cc54c3823dc5fe2',
        'b4f602bd125311e36748',
        '41b2cf230bce31e69c7c',
        'd619febd97bd0a54a269',
        'd6a31e15311677a02949',
        '273f2b878b691cc64d52',
        'b85a9dfe7091208d4635',
        'd473a64ee0a1d3282ffb',
        '4ec52ce47c16b08c836a',
        'ed11c5d06ea9e49bac14',
        '91f48694be3ca62dc6c1',
        '40886f03178da33e7acd',
        '392acf1d8508466f06bb',
        '07debbb0e5654aa838ef',
        '5ff169752b21e43dc8fb',

        'c31e7fcd5e7c43a4e340',
        '38152e6081b65e05d9c3',
        'e5adcd2ca1ad3dc191aa',
        '4a52e7e0c749c6bf5b23',
        '30eec8499ef3a8dd7d84',
        'd887cfeedaf6a3a7036c',
        'c449c9a8c5ac125d6e96',
        '8352fb92c8a32edd9bf9',
        'a09a984f032766b8fe6c',
        '6edced8e82243e09660f',
        '38cf8869b7c748c07353',
        '057accaad45542c98a64',
        'caf8eb85d971c7265a46',
        'ac8849df27835101c04a',
        '636458a03b47b02c9c62',
        '4f75d65eb38f9461cace',
        '865e5c2db5575165c34a',
        '78164e1fa34911a18dca',
        '9639d627bbe7767f0e8b',
        '5148b65f273ebf64128e',
        'cc4aa3a850a7de8ee796',
        '8bc75b49a7d9f7127e0e',
        '5b69c750b7451953cb0b',
        '6f895d52338fea40fd00',
        '1e762f2254144dd4b7ab',
        'ccc4b95c35a7ff2124f6',
        '71d4fb8b2fb8f526c85c',
        '3ebb07a1a4be689a6e69',
        '0a7afe84125d84a4cd21',
        'f54538880240f6c50d2f',


        '49b68cef1d747b72ee5b',
        '782c254fb08c5885fd2d',
        'd69341887917334c0749',
        '6fa350ac8875ab8965de',
        '08af9ffb1cde3c802cfd',
        '779324664253f8e1b4c6',
        '7d895bc41fe10ebbbb14',
        'd5f915b50e5eb9af456f',
        '0d96e17645aafb75272c',
        '24585fb174f9a2cf1131',


        'e0a0691f2923b54bb761',
        '52ae088a9c4a08fca9d4',
        '8ababe523ce0a463de8f',
        '8398f1417739049bea2c',
        'b35414ae3e2db6b364ee',

      ],









      hmxstoken:['ed08f9bd98f75d95c1452533ffe08f16c5db1298a0654f329b3b050e4673a966'],
      xqqhmxs:[
        '82e74f816dc4aaf13e11','f8e691369d51680ce6ab','5ae4ae27d1fb9b88da8f','8aa7ca742fec2d29cb30','0bf6bbe6e472721ca313','34527b41ccfc6a58d079','063d21841f45f3790cd9','9db4117e2a5c019a1a9e','d35d672e9be1a2223305','9edc38c2142b1824c285','d0ae14c4b16ea914ce3e','3386a9821dea34c5bf35','31c801f49ef2a6599290','2d2e1c00bfbd78d7c804','be9494fc1b03ad924334','9553f101124dd6a02fd2','795e2f71670c11ed26e6','a8054c6ae185571629b0','149d3ff15f71cccc13be','ec1b7a4f0d7e6998e9b1','67f5f34150af74c27fbb','69852a1b604ad84fb28a','604d74d3aad928830044','f8de6e3b964397c791db','79c70abbcd19d570927b','5dafa61f3c141f835116','e2cb91dfd7ef1dbeb5d7','c00ea68fc44196d28b76','2ce502cf46d54786b2a1','e2af6fb1560566dee713','317a4e3294070f1fc46a','a902e2e4dc693bc113b1','cf715b3cba453443e646','0539a377fe98b522a6d5','24088457edd66402ec34','4a7527b7454912540240','2d4feb4284a4991d85b1','10aeb10ab43e959b218f','eb8942f074dffd36558e','cfe30d0e6fbebbafe9a5','9851cd566e5a6462ce45','000fa2f4fa39cb135ddf','489c9fd304d934600dc2','5dbd344d11d26db0f116','304146e7340876e9149e','26299b55eb408440aac9','ae07f72f378147c3cc18','7e84e7a729e5b7fddfa2','ab97890183ee528dc9c4'

      ],
      xqqhtxs:[
        '50bcf0d2878780523103','a6544a082e6d263e02f5','861a7983b3541fc3507b','1ca05da1a0cf672fbafd','b3e20f819cc65288b076','a5c4ae9bfa013b54fc9c','0da5e1fa5ff5f6130586','15247ad20846165b09c2','de3bc1c58aeae4012d22','ab96170c221b92528598','0c6a84dffc2165da2df6','260b58af07ec699186bd','9666f46b4ce4551dc44f','6932dd2148c55cbf7078','a2495ea0e55a0b292410','8b9e4ed0685d74d4bd73','59290766898665a13520','134de771c00af10625b6','a0fb2533b26006911e20','9ba61e06b64f39938806','b3346d278af764bd5e65','a38d358eb0efb71046aa','8f21fd277c9917edc3c5','8b360fb9dd98a1331364','71c1ee68a091f0c2dbfd'
      ],

      xqqqexs:[

        'e5af9d3f70ae962fca14','0c82f5d725e68a27d142','707df5df3c4280ac657d','125fc1b7684cc0f6cf52','7e2ad879ecabbabdb4a7','f7acb67d16df1f00c560','3022de5b7c50f3e9fcae','0ce43822d648f8383a25','896ccfa3210aea06e220','334f563b77bb6daecc87','e438e28063c33059b572','20a19e102aa3b649c5dc','1fd026e480da72a49018','aab1638bac25661f452b','607ed3f8aa1ac8b65f50','bb19150487d59d243fb3','71dadecb6880327723db','da484eacadab118f112b','3dd5693261a03923ab98','6179e136b60559d84d05','3395a32d7fc1ec8ba779','38e3b04fa973e1ce60be','97b8122eca9c3534886b','ba769cbc352f03658ef5','9fbe46b7a2f1907b34e8','035bfbea194058071b9e','80fc239f21d6f76415d6','1193561028294b080577','21a285b760629338b1f9'
      ],
      hxz:[ '0ddcd91215f644bc9a63',
        'c4f4a1b84b42f3dc0dc1',
        '5f224ce2e55e0a342f78',
        'e07a18aa50a052186f14',
        '926b7cb993a6898f71c3',
        '5a2691650f8a33ea6840',
        '0f55b275f8b5d2899fb0',
        'a177a864fe663d4c35c6',
        'b7bc68b546132398bed6',
        '9fdebc95d69b0304b57c',
        'c3aa2e3da7b04805aee8',
        '9a1cb0cf26c72fd56a44',
        '67550d978e29e18beed1',
        '3498c64c74e306cbf54c',
        '84fb38f057052ce464dc',
        'af8109cba77836a2b796',
        '50fb96080e9a791c968a',
        '7163343563de84927706',
        'dc87d673815bced3ccaf',
        'e4a75fa3a8262b7b1a05',
        '664a84be28f800799381',
        '5264a4e5f6b74dacdc24',
        '8a60b5f55f66380425a2',
        '9ed2f47793e4bd8d2d8b',
        'cecdbf8293a84168f539',
        '85974b1df281ae4882aa',
        '720969e997bbd86491dd',
        'f962103e4a458979d13b',
        'db083162e379268f1a4e',
        'fb8d8b68eafc9e701799',

      ],
      ch:[      'ef2214f7c21630c1f221',
        '35da84ffbad44e062ba8',
        'cd2923ae58899db9b72c',
        'e826b8253ba380bc098e',
        'a15a24e2b2b79cff6c45',
        'ab642d3f7778f8914d60',
        '5e73ea1eb16997931ea3',
        'a1b8aa787ce29f19a4c6',
        'b2df04590dd1ebf97679',
        '044b52b51c33e5959927',
        'dc0427febd611518c6ef',
        'ce7a4035c02dd65a3ea5',
        '72fa029edb6a64ab291f',
        '8adc6e6859144aece0e7',
        '8542593d49e6683235ae',
        '0d6a9b263d356258f3ea',
        '61f6e9e02a6e16119063',
        '006c26538ff0559e8bef',
        '959930e05f2c604f47d2',
        '795bdb40273b9f20c7a2',
        '2af11e06b8b7dc7038d0',
        '0257ea55ab44c5fe27fc',
        '4bad35c2fecdca4223bf',
        'a1c09cb15535df799b72',
        '05affa995b6304d87d0d',
        'b5056e60df7f17592485',
        '59616ff26dfac1d8251d',
        'b15de5af1324a2ac17a0',
        'a5f4fc5eaa1e8ad14f1a',],
      wh:['ea16526d24ba3f178013',
        'a6b87ae122696784c0ae',
        '13edc6df50c833a470c2',
        '1847dabe9b01d469bb3c',
        '8dbcd2f2d8b4471f54d0',
        'e95170cf7d7aa00a8905',
        '1796a796c35cea089e23',
        'c7eb4f852cc4f92e6524',
        'ba2115dfb75056948fc6',
        '3517a81bc184b2f81d5e',
        'dee9f6c0a07cda00c04d',
        '2a30aa56486de6354f42',
        '188311d2d3e779682e41',
        'ded8629ca5e7537a58d7',
        '9c0f4396a5b63645f004',
        'f00b96e97df5da5c0ccd',
        '293d9dc68c39b8bf9aa7',
        '46c9389f4bad1a34b074',
        'c0da369bc4bd64f336de',
        '3c66dd88f6664eb00716',
        'cd11ad3f8b2e95ec951a',
        '3a5cfa90a51c6b937cbf',
        '27719d627d8c6d9f8e31',
        'fb2069a2e360d38b5545',
        'f317cd72f84874b0bbc0',
        'edb56d19f4d675e942e5',
        'da573104aa469a1c475b',
        'fce8c6c7582a79344ade',
        '290f757e9bb92d69bcd6',
        '97d817968f2c7ff4ca17',
        '9a6362fe7a6f98551447',

      ],



      klks:[
        '497665e4df0af7581c8d',
        'de467dba5d48fe983387',
        '6a111f6240ecf0c571ee',
        'dd2be65686d413eb2945',
        'c78f95362dd7f30f7d89',
        '7ec25c61788ea075f8c6',
        'ccc04316d353fdf4d7ac',
        '33c81cac7e81da8eb9c6',
        '8cae2011454853a15ccd',
        '8fbff87edded1120e1ea',
        'e835064dd0f3124677f9',
        'de0a3ae55029a60342e0',
        'f89c5cc8f403311135ac',
        '2906b8e56c0a87830555',
        '98dd81589a0fef9b03fd',
        '783716053f5e842d36ad',
        'c0240c598212ce85b8cd',
        'fa635b5149a2733decd2',
        '93a6e7bd0a1b8bee0af3',
        'bcd90f1c488e4c444fbd',
        'aac1e65dbaabf8fde2f6',
        'a3ba70dd6bd0c9e64cb4',
        'a4cb40a06ab9cdefd338',
        'e8b725f7b868a8286a5e',
        '57d12efd1ad7a63c7b6f',
        'ae5db0be1e7cc8589d89',
        '660d9634150eac11acf6',
        'f879800111dcb50d8447',
        'ed329332575af74a8e58',
        'ff309b70b1b46a913f35',
        '6bbb854f8a0c85ac19d8',
        'f3d0ba47af200db69b3a',
        '912107cb143a453209eb',
        '619d2d90d1b4f1f6bccc',
        '2a21bcd462c40854bbd0',
        'e90aea90702258cdb9ac',
        '7aad81317821b399e799',
        'c562fa93f9ef72b93d5e',
        '1114c181239c313a6a15',
        'ca691391da48b11ba280',
        '665b697b2c424d32b40d',
        'd12faf64d358b8ac8775',
        '4c51e65dd5d978ae154c',
        'c0b324d83bf2a3de704b',
        'f0ad9d3a4bacdf660552',
        '1ebe940eea8d8d1f21f2',
        'fa7f450141e33d26dc1f',
        'a693491239d8f5e9fe1e',
        'ebaab3b7791fe216e9ed',
        'ceaa585fc486e271d734',
        '0f90bc81d11c99a3d2e4',
        '227f865017a363d8c7de',
        'f05e729f708bf6413987',
        '22b7df987018d2044b40',
        'c58508d68d20f59caebc',
        'b85f69ef2bbd1f217fd4',
        '46312369ce569c109b20',
        '78bac7e5827d308b2b9b',
        '24a91cbd80461f38ec78',
        '695e7ceaea82369aeaa8',
        '13ef49618ce600025102',
        '4b819ce558aeb19d8295',
        'a1979c5f89a0a740bf04',
        '899dbca7dc2f53be1c43',
        '97a4a3e1e03d85e8eca4',
        '66cb3347584b45013c5e',
        '0dd00e3c2b22638553bd',
        '98b44ec43e8f63fca340',
        '41801325a9d6a1edadc8',
        '11ee7bc8e8794d61fbb5',
        '8ee977fdf662e669519f',
        '6ee02a3e48189fb077f5',
        'a47f56c782b1e0c76a3a',
        '3ff537e2e0cf1f426d0a',
        '2ecf98e92d4ae02501be',
        'd1dced7ebf85ba46d5f9',
        '567bdd59a54b7004a357',
        'e110d1336de13a333c2a',
        '0c4515d628a453e246b4',
        '39d0e578c57f0db99ee1',
        'c4b5192ee9b98c4d6c35',
        '03702a1961678972f86f',
        '9599c666b4cf0eed8062',
        'ed8b97c04aaa14980495',
        '9b1aba618701b83ee89b',
        '4a3fb74f5a3170e64a60',
        '65e3bb048b21e88fbb41',
        'bf355a1551748f2b3715',
        '697ada72bb527e0ccd27',
        '409c3f2ccab7a08fdc3d',
        'ad45bc0c67c442696975',
        '499fd20bb9f548982c00',
        '3d31761693d2520e7c23',
        'df098dee1144db7e69cd',
        '1c0ab3980c2f23e6c12b',
        'f5e62efcafe8488169c4',
        '0c3a90da7da952ee4667',
        '7f01fb56e417516ea9f8',
        '0990918065345220f6fe',
        'cb34b12e6d4e6ff32305',
        '745f290121090bdd3c07',
        '46ccbf33b1b2784841ca',
        'f66404ef8aa4aae0ce69',
        '5e08b545303f7c753ffd',


      ],
      klkstoken:['96583eebdfe6abc8d6d7f60770a419d6ce850eecb4ddd94de95a0915851c7cb2'],
      ssxs:[
        '5a2691650f8a33ea6840',
        '2af11e06b8b7dc7038d0',
        'ab642d3f7778f8914d60',
        '44bae8e823b0281491f8',
        'da573104aa469a1c475b',
        '50fb96080e9a791c968a',
        '2b01f55610d54835c345',
        'fb8d8b68eafc9e701799',
        'ba2115dfb75056948fc6',
        '46c9389f4bad1a34b074',
        'c7eb4f852cc4f92e6524',
        'a15a24e2b2b79cff6c45',
        '5264a4e5f6b74dacdc24',
        '85974b1df281ae4882aa',
        '0d6a9b263d356258f3ea',
        '1796a796c35cea089e23',
        '9fdebc95d69b0304b57c',
        '9a1cb0cf26c72fd56a44',
        '664a84be28f800799381',
        'e4a75fa3a8262b7b1a05',
        'b7bc68b546132398bed6',
        'a177a864fe663d4c35c6',
        '3498c64c74e306cbf54c',
        '3517a81bc184b2f81d5e',
        '293d9dc68c39b8bf9aa7',
        'db083162e379268f1a4e',
        'e07a18aa50a052186f14',
        'ebfdcffa190afa272851',
        'cf2797562423b1801502',
        '2a30aa56486de6354f42',
        '5f224ce2e55e0a342f78',
        '67550d978e29e18beed1',
        '9c0f4396a5b63645f004',
        'dc87d673815bced3ccaf',
        'cecdbf8293a84168f539',
        '7163343563de84927706',
        'af8109cba77836a2b796',
        '8a60b5f55f66380425a2',
        '0f55b275f8b5d2899fb0',
        '926b7cb993a6898f71c3',
        'c4f4a1b84b42f3dc0dc1',
        'c3aa2e3da7b04805aee8',


      ],
      hutao:["5a79c15cbff77201eaec",
        "e769239bc5d7f3391cbe",
        "f2bcb7423fb7e709bd75",
        "a1279fc719715d34f3d7",
        "1de654cf9371559b21c7",
        "11f109c0f4bc69f3e1e3",
        "59f41ae673f78d5bfc5e",
        "7e8603637d043d44f301",
        "78fbb8b7f723f245093b",
        "106567be2c8fd9af44e7",
        "a2c0bf12190f0f80f5f0",
        "aa13f68dab4f4105a34a",
        "fd715ba43a4b68abd183",
        "e1bbfdfec66e81c2888c",
        "ceb014f8df8795184105",
        "99438b02c75adacc5ff3",
        "bb4118bfe3f8bba1dc6f",
        "0f0e233008caf1d3255a",
        "a197b71b7e95d025a4d4",
        "9a085d8501b84f0b72db",
        "bfbe0e175efe54d70352",
        "570f64f0b7ba3097d86e",
        "b257fe3d0c74ccf89eb1",
        "50bcf0d2878780523103",
        "e52fba2ea51a38fbb481",
        "604b4afca554a210d5a9",
        "a85c8afd55ad5680cb42",
        "c72281f827d7ab5fe7e8",
        "3ee495b05c80f4c68b19",
        "76638a36d568d2da9d69",
        "69ea7a34bbb8773ba553",
        "397a1b667cae16b4e3cc",
        "1c9f8781c18c895f2627",
        "a6544a082e6d263e02f5",
        "7bdd9b9608a9062658b1",
        "42c5f10cdaa245abfa5a",
        "26bbcf579474611d55c3",
        "fade206598687ec286d6",
        "1126298b19a6e97c5af2",
        "0587e5998df8533b4911",
        "d097bf58b9a89c2aa76b",
        "1b626e9b403607fdf5cc",
        "416663bf1605dc9d1706",
        "d12b263faf4689dad519",
        "1bec67bc1ecad2a3e14c",
        "19cb4a2b1f4d603f68ea",
        "51b1ec831cf7f2d56979",
        "db092caaae6356dcbb06",
        "2009e24b3548b56a27ad",
        "87416b6dd257359d548d",
        "71ec24a022953d52482a",
        "d3d7ba5c457ca1027ac7",
        "d8efc00fab9e3b9ab14c",
        "cec4920adc4caf0b1c0c",
        "5b729b083062b7d8a82b",
        "8d9515fe6bf16042ffe8",
        "35d2e70205f6c64c8dad",
        "b2572768f925b411afa0",
        "33aadd6b46f9cc366cf3",
        "53aab0fe026b50287fa1",
        "a032aa8ec333dcb40b8f",
        "77bc959962a5536ac2be",
        "a1446ae88e2ae4e27991",
        "1d2552764c0165fcfacd",
        "ff1141132d8c28a58e80",
        "bb9701662b08340114ef",
        "88dbcc5b631099013350",
        "0c68a273d5fc074c6a26",
        "76c9a208ac074a033bc5",
        "4f1a82cf15297082d122",
        "3da9c64746ec00ed37b3",
        "729c43fbf2a663fd13ba",
        "4a5efc7bf82bc743b02b",
        "bc76675bbba87b58158c",
        "8d3f7e75a4911106e484",
        "3d8f6762bd04f22ddb10",
        "0bc2712c469ecc80eb3d",
        "2049295abe39e76ad940",
        "f4885f9823bf96e6f93b",
        "8d9e8fd241aa1407700e",
        "95bea3b25793e2933776",
        "410a0b92433845083382",
        "fcd3246df022d25af433",
        "a2f8c569be076242288b",
        "0461b5c14f68ecb02b05",
        "e0530a4ff637adf8c866",
        "a6045bcd3d7d453443fa",
        "f3af1127afe466ab577f",
        "861a7983b3541fc3507b",
        "dd19fd529e045d5387c2",
        "efe2f73911636849f0bb",
        "2030da82dacdc82893c0",
        "ac99151ab274ea093e57",
        "b509d959886af3f0143a",
        "b22f4f37dd038b0f51f3",
        "5eb93c98c9a79dacf881",
        "1ca05da1a0cf672fbafd",
        "d57b06ef540a21a57e55",
        "2d5a641e486fbc196d10",
        "58ae880e74a23af43d2c",
        "36fbfb6993343b6b82ef",
        "c9c8026f6ea160626f48",
        "a625e1a05957d6ffe361",
        "a2ccae8a8f7100f07ee5",
        "8771052646bb38c22140",
        "335d35eaa4130b4a2c28",
        "57227aea7f00b5bf97ec",
        "b097b379e6d01871733a",
        "ec6d1f93f475fd2e3be9",
        "35912b654784dee089cd",
        "a41db374b9eeedb9e19d",
        "34f8b7e5e9712f86783d",
        "7640f286578bcdd76604",
        "324e389408537266e064",
        "400f50ad2502c6c9232d",
        "46c6893d91547a7df14d",
        "f09870e1954e3eb90a1c",
        "25f71076c98552c781a2",
        "07f9339fd14952fc90cc",
        "64982c6e2742960c8eaa",
        "b3e20f819cc65288b076",
        "41a5a08c749eb0187e3d",
        "558cddcaeb93b39af714",
        "e00a38d332aed36597bc",
        "13f7406709b1fa21cf7d",
        "b9deb1739f001ac81077",
        "3934bf440c42abc2dfcf",
        "a5c4ae9bfa013b54fc9c",
        "114789c95a2071a8d396",
        "51b6794d948581969877",
        "98819daef350a831d9c9",
        "de262a1aa497b49b4acc",
        "3e85ddb5125e48845090",
        "fccf7ce7b7aec119fbb3",
        "58744a27b96f901f43ef",
        "d4faf94adcd11d0f44eb",
        "f713b35dcabad92aee5f",
        "0b48a0957d69eeb83e07",
        "a6fcbbb7e2f51bb39588",
        "26d2744eb9cb44e2796f",
        "0da5e1fa5ff5f6130586",
        "15247ad20846165b09c2",
        "de3bc1c58aeae4012d22",
        "ab96170c221b92528598",
        "0c6a84dffc2165da2df6",
        "260b58af07ec699186bd",
        "9666f46b4ce4551dc44f",
        "6932dd2148c55cbf7078",
        "a2495ea0e55a0b292410",
        "8b9e4ed0685d74d4bd73",
        "939a571151a419a75d70",
        "97167414578e2b0f172f",
        "b05ed5a639de7c25eb5b",
        "90030a0c2331954361e4",
        "9b34ed7226b1cd82235e",
        "cbbbc90dc549025a4ebf",
        "4cfbdcc6ab61c94bc6db",
        "3b6aad353ddddf3eda66",
        "1583cce3577a37c6c6b4",
        "305ee4783acdb33c391e",
        "f9be587c471b3fb934cc",
        "dc8f702c4e7f3a3d0d9a",
        "0530eacf53f4b3b59acb",
        "1e527c6ad7e339527d70",
        "3bcc077adc5b744b1742",
        "c20e447dc5102c6b938e",
        "2768253db2dae2852edb",
        "6cf85cb73c2daf88513b",
        "6a5f68f391f3c5130fa7",
        "cb4cd5b74b6853098ff3",
        "11b675a6f6dcd2637d3f",
        "2e24ff5d49e29b3ab092",
        "6688ca4b6909f45cc499",
        "7ab048ad9fdaba20ffc6",
        "3dc7bde23306a8b2fd3c",
        "26afffa22096c075cc32",
        "38de53a7dc0d6033266d",
        "65565ce263b44c1c90e9",
        "ba41d61d30a9ba3b46bf",
        "6db50a2433ae153ce222",
        "7e3c38abe95817b872bb",
        "89cd37c17d43bbf42a73",
        "48b237da08896ff4cab2",
        "2e60b579aa687f438b85",
        "7edfabceef87193d4fb1",
        "a24949849993c7c5cf7a",
        "e6f6258b5c18a34a3624",
        "e520e0bd084d689df2b5",
        "e5bab16d16d8ccbc7473",
        "d8620a4477e4afd70197",
        "7f9e8d66d986154b9b82",
        "b6f0caeb4ac5b198fcb3",
        "8746c745e9c63294dde1",
        "59290766898665a13520",
        "134de771c00af10625b6",
        "a0fb2533b26006911e20",
        "9ba61e06b64f39938806",
        "b3346d278af764bd5e65",
        "20707ef0784d9dd48046",
        "c1cb3c0b5a2bc62f71b5",
        "05fdfe5a0b86d8fc0e34",
        "ea315b0b354add3de557",
        "3fda3c7c2bf6985cdd06",
        "75901a96341430abd2d5",
        "3dd42a9c5d120d432851",
        "439cf50da2fb64af0c66",
        "a38d358eb0efb71046aa",
        "e99f2cdb95c43182353e",
        "8f21fd277c9917edc3c5",
        "4154fca3a5ccc8382931",
        "8b360fb9dd98a1331364",
        "71c1ee68a091f0c2dbfd",
        "504ed6c8fea05bbe9d50",
        "815eb0105209040a48f3",
        "3162496b044107c9a8d0",
        "3c85c35ef0beb8cd938f",
        "3efea621ab0b2c5b40f1",
        "9849eb897fce24c0e797",
        "331b2caa59142c8e5d34",
        "3728014241949cc95b58",
        "8b1052193bdcae34b9fa",
        "fccbaad1407e153dbdd6",
        "d87fc0a7a124702f7d07",
        "e486433683619e574dcb",
        "8f3b7ff558eb0932e4df",
        "cedee7eafa46ed9ccb59",
        "38e69e18353723784752",
        "c585e9bebf131238f07b",
        "ea371df314cd67febc50",
        "ac9dfd2a13eaa7bc843f",
        "46d613e729b9a6abb692",
        "d8b9be3723849c48dc78",
        "a1747896cffc1cdef543",
        "8641b16a2531b26aec37",
        "0d9aa62a5e0dbbef49f3",
        "99be3166b2e857412c07",
        "fa2b92c822750676a8aa",
        "baaea3f6e5d4d87fc6f5",
        "b64fe5c0cd442522f524",
        "a2cdcd40f5b758d3818a",
        "8813daf0d21ebf2a54ec",
        "dad6bc729a3462cacc72",
        "57f8bea3eabb2387982c",
        "e6a4069ffd5a9ae26824",
        "cb277af821c7891efa31",
        "6abebd974f6a4c52037f",
        "5197a45077681f8f2192",
        "87698e69670c8e222be1",
        "6b07fe9302fb66e7ae60",
        "9421dc36b5e4c7b66705",
        "7027a905b2b151ae0ab3",
        "cbbf99f389be6c59a938",
        "d5dc72e1203f96dea21c",
        "d590fb58e2d1b2788578",
        "13fb2bce61700d8060d8",
        "35409241382a84dc2bde",
        "64d04a48d4a514b68795",
        "714fe71d8c3c86e17676",
        "ed77541cc13adb205a88",
        "00e15aa6d340e235b236",
        "0eeb6537b037ad75bb2e",
        "f1c57cb761bf382690f7",
        "f949b8210db819ee3803",
        "a8bff4803318ebe5aa84",
        "27d8b6b113621aa5e5c1",
        "966b21c56363c92ef06e",
        "1b1218c204dd9d0d0fc4",
        "229d9d5794d3c8a65f63",
        "443b99ba60f582a951bc",
        "694ce83459320035bba4",
        "a8a1a1e9e011a3125cdf",
        "c61f808381511694cbcd",
        "09a288db17dd483c222d",
        "dcb2c8b60546c6d42a3c",
        "ca3ea63ff49b23852985",
        "e0217d941c3da0fec55d",
        "fde819850720e15e5a9c",
        "34d609b5523865cf3f2d",
        "4e17d831795480940c76",
        "f4717001201bf3c85db6",
        "b26cff453c4f4917cc1f",
        "742da3492d5156d52d57",


        "09a288db17dd483c222d",
        "dcb2c8b60546c6d42a3c",
        "ca3ea63ff49b23852985",
        "e0217d941c3da0fec55d",
        "fde819850720e15e5a9c",
        "34d609b5523865cf3f2d",
        "4e17d831795480940c76",
        "f4717001201bf3c85db6",
        "b26cff453c4f4917cc1f",
        "742da3492d5156d52d57",

      ],


      hutaotoken:['9585c8010cec4c4919c541d224d282eabe686b0a97511e8570449ce8b199b57f'],

      feimao:[
        '430f6be1f5ef17f8fc2d',
        'dda7b0f100046120ade2',
        '7e6e10a92d7097374e4c',
        'fb4de508ffd3bf5691df',
        '643cbb3b2cba2cfb7ba9',
        'feae3b5801513bd46ddf',
        '48e6660cd13cc9d68c0b',
        '2f0f52d370634a3c4e84',
        'ed874248140ef3a4b9e8',
        'c593b61778b776e2bdb1',
        'a22a4bb825ab79375b8e',

        'c98696e9f6f336afffcd',
        '6792581d0280e1fe0d4a',
        '64eef41c9b507eee50d8',
        '1a4855b0577d96110eee',
        '5d1c451e8d019e60d3c2',
        'ae3b37e18d5f5d873098',
        'c4bfa29fb6febbda99f6',
        'd520d315c488254a1372',
        '096afe63f241fef94aac',
        '6072fd2db6b8310625b2',

        'bbb4684a3fa80b752955',
        '7f68ea04149d36d4ba76',
        '084c5fbcc530383bb794',
        'b53883d6cb400a20bb19',
        '218218419fe7cc1d0c6e',
        'a22a4bb825ab79375b8e',
        'cc2410b96ed7625e0834',
        '049301ade15a081e15a5',
        '356ded17f9f944d0dce6',
        '302bc2407e2496b6df5d',
        '0797a451431d17fc5356',
        'a8927868b39e2d273067',
        '5297b10a4029bd52c3e3',
        'ef338f8d289514baf5fe',
        '8d35542da79c5566a7dd',
      ],
      feimaotoken:['f76d300cfd4867d959037d4bf72b0742a4db0304a0ccebbd56fd1a51302a03cb'],
      mtjc:[
        '1ed11a001527004c7013',
        'e892c01217167e8d80ed',
        '6c96f1a19061531e8e9e',
        'c1d7b282ada243a5b644',
        '8b6c503f25adf713fe4a',
        '5528cc7828cd1c7fae92',
        'e9f866eaeee7b7847b6f',
        '0dcaa458104c81a73fca',
        'e39dd828b50d2f8f6aa2',
        '332ab5f3c4383657efb1',
        '1889c71c13806d94f6b2',
        '04488544e49a87565875',
        '9719a7c074ff609e9c6a',
        'a7e3ab0eba66f3d785f8',
        '85fa09dc1650f4e039ae',
        '3545676916b1c2da0c6f',
        '45404a7d27e0b46ed182',
        '6749367032dc8c3e91cb',
        'e31501653d43feb609e4',
        '3ce4967a303d91c34d94',
        'b01b4d8f62f06eee1c48',
        '54bff64e1defdcec2c94',
        'fc3d01af3d105f12ce9f',
        '4fa7d22ed052d1fed135',
        'cceaa756aa43b581e938',
        '942894b7ecd1e3e8bcb2',

      ],
      mtjctoken:['6a6075d085291f45aafdfe28509eebef09f305990ef6382686d8759758e2b878'],
      shengmitoken:['6cecfbeae4e923501359edc9964d89122d7912b8fd0ebe4980e7b8b142e1246e'],
      shengmi:[
        '561540669842179407df',
        '149b6e43b278dc5e88fb',
        '1e0e156209e25ad902d4',
        '4098d0384f0e05ba3cbd',
        '57401c0c3b86d8605861',
        'd2a372b5eff6233ec1a3',
        '706a840b8d27f57544a6',
        'bc19b83613f16f81021a',
        '6b9220644b293b24b13a',
        '0698b4e2c7fd7ffdec45',
        '975351d0f7d66c055013',
        '405926e7d076ee996389',
        '7f63245bbb4228fb296c',
        '5bcc224a5014a99e89e4',
        '3238e2673c49181c8f65',
        '6d8d66ac4e3af5b3e273',
        'e251dd35bff32f0e034b',
        'a28fdda9f5d02b82bd5a',
        '8cb3d35858ff91bdb3d0',
        '77f42ae9203faa2221ff',
        '1fcc90910f2438b8931b',
        'b558960c46c04a7b67d3',
        '8715691086fd0dd54386',
        '41630b7a0c02c88b6231',
        'deee741895d8641c7bca',
        '0f3d6e06502fd533c685',
        'a7dc68b7ba302f5517b3',
        '90a0c28b146b1312049a',
        'b051be218ef7de80466f',
        '96d6e87ac5fdc24d9001',
        '96b6fd438bc96b3d21d4',
        '035cb06c6892a8934264',
        'd53cbfb7d81f7a83b551',
        'c4702c9c88bd77bf93a7',
        '22f41bb53e39dc1ac45c',
        'e72a209e1562fd647ee5',
        '3d7ace7bbeb8204cb561',
        'bf1174508a1db5f1f9e6',
        '7f41b1c7063fb84bd230',
        'd5a97995d441f26c7fb0',
        '827e46459184d11cffa3',
        'e03255faa68b22c054af',
        '75db4ae16b05638ae27d',
        '48f6879b28619be3cddd',
        '0f2156eb34c51d13aab5',
        '492156dc33e424804b36',
        '7bdf53c0110a191e011f',
        'cc795031a5ff066a6c53',
        'bf3ff8c9c36c7fbadcd1',
        'e05b8b96878ff18a3655',
        '71a6d25ae81dfbb5ea55',
        '2dd055e3f59049160ef6',
        '41fed385e700ab70916b',
        '1095b15e40b67f13a574',
        'b090b40d47747788db3d',
        '61859398fab1d844aada',
        '03434f7386d5989d7f36',
        '0d5889e30c78dd5c019d',
        '36d16f3ae826d1e2209f',
        'cfc02773622087fc61e0',
        '12c89522dd41e6563ed5',
        '881e20048175f4884546',
        'fb6e8ee77240ebd12e5e',
        '79673fa0440a0a65a905',
        '4b2d79085a01729530ef',
        'c5cf02daa8c160044440',
        '2657d021838499971335',
        'f2047e7a6dd70728f757',
        '7b2908cd39a2d5c3b136',
        '216cf9abe54bce1e06b7',
        '38401a0661550c9204c9',
        'f65c9a85b3b3d7e6ffa1',
        '4c5a534754465c49388a',
        'edcd09ed2640f97881b7',
        '44cebf8be0ffe3a88c0e',
        '9c905ef14d436058e600',
        'f00357642a15005ebe89',
        '366d9366c25fbaa77043',
        'aab9c0e52f8d90271126',
        '5f21fbbd42589761c2cb',
        'd0e4280c6ed4c94ecef2',
        'd3a7fa98efe7bc52ac35',
        'd1c806d510e3c4074a5d',
        'cce15333181484222f73',
        '427a978771ba8b0879cb',
        '3260e221e7f05c3b6a96',
        '239f94a60257e09660e5',
        'b558960c46c04a7b67d3',
        '8715691086fd0dd54386',
        '41630b7a0c02c88b6231',
        'deee741895d8641c7bca',
        '0f3d6e06502fd533c685',
        'a7dc68b7ba302f5517b3',
        '90a0c28b146b1312049a',
        'b051be218ef7de80466f',
        '6dec552b328093080757',
        '8a3958214e6588899a92',
        '5eb5e6b4bc84f2aec210',
        '96d6e87ac5fdc24d9001',
        '96b6fd438bc96b3d21d4',
        '035cb06c6892a8934264',
        'd53cbfb7d81f7a83b551',
        'c4702c9c88bd77bf93a7',
        '22f41bb53e39dc1ac45c',
        'e72a209e1562fd647ee5',
        '3d7ace7bbeb8204cb561',
        'bf1174508a1db5f1f9e6',
        '7f41b1c7063fb84bd230',
        'd5a97995d441f26c7fb0',
        '827e46459184d11cffa3',
        'e03255faa68b22c054af',
        '75db4ae16b05638ae27d',
        '48f6879b28619be3cddd',
        '0f2156eb34c51d13aab5',
        '492156dc33e424804b36',
        '7bdf53c0110a191e011f',
        'cc795031a5ff066a6c53',
        'bf3ff8c9c36c7fbadcd1',
        'e05b8b96878ff18a3655',
        '71a6d25ae81dfbb5ea55',
        '2dd055e3f59049160ef6',
        '41fed385e700ab70916b',
        '1095b15e40b67f13a574',
        'b090b40d47747788db3d',
        '61859398fab1d844aada',
        '03434f7386d5989d7f36',
        '0d5889e30c78dd5c019d',
        '36d16f3ae826d1e2209f',
        'cfc02773622087fc61e0',
        '12c89522dd41e6563ed5',
        '881e20048175f4884546',
        'fb6e8ee77240ebd12e5e',
        '79673fa0440a0a65a905',
        '4b2d79085a01729530ef',
        'c5cf02daa8c160044440',
        '2657d021838499971335',
        'f2047e7a6dd70728f757',
        '7b2908cd39a2d5c3b136',
        '216cf9abe54bce1e06b7',
        '38401a0661550c9204c9',
        'f65c9a85b3b3d7e6ffa1',
        '4c5a534754465c49388a',
        'edcd09ed2640f97881b7',
        '44cebf8be0ffe3a88c0e',
        '9c905ef14d436058e600',
        'f00357642a15005ebe89',
        '366d9366c25fbaa77043',
        'aab9c0e52f8d90271126',
        '5f21fbbd42589761c2cb',
        'd1c806d510e3c4074a5d',
        'cce15333181484222f73',
        '427a978771ba8b0879cb',
        '3260e221e7f05c3b6a96',
        '239f94a60257e09660e5',
        'a0aeb5d67c2a73ee1ab2',
        '4434e4caa79d41fb0d27',
        '5b2335e70e44ae0dfaf5',
        '44c5fdf35b48d724cb2e',
        'efd9c9eef9e625024ed2',
        '9aad90e1359fc7175ce5',
        '8e362246f280a7bf296e',
        '911793229e36716e37ab',
        'e15f0c201193da715aef',
        '2f89181e4b9d34339371',
        'e80e5f81e5ba85990a26',
        '52ccf7279c50175c7432',
        '83fb1de82d00ff5146d1',
        '39948a2da1552d24d3d9',
        '56b122f852a4a5c6814a',
        '963801ae9f929a578a72',
        '7cb8ef7f10ff9809667f',
        '92ba382874e9cc49d84c',
        '1606b6d070dc1be6ed01',
        'd46d034c0051a25dfed8',
        '479fa8ab7a8162dc19f3',
        '1416ef9ba22db17657a1',
        '17babbb52f50fb005352',
        '45cf66af9d7adaf3e3c5',
        '59bd3a0410a3de82b49c',
        'c8000c1b463c07560fff',
        '714e869b8e95e31545be',
        'fb257e867994a7aa7c36',
        'f35fbc987724eb9354fa',
        '94f2fe19a3987144aabe',
        'dfc47bccc0989fb1b54b',
        '2f6e6e152ec7877ac1b2',
        '0185898e2c38847d03fc',
        '3ef0c9ae1f8b62667533',
        '864232f78273c96a7243',
        '8c6a8117d3964695dfa1',
        'caaeebb1fe220a291ffa',
        'ec34e6fcba57ffc35caa',
        'fe58fe5ab2efd37519a5',
        '42f2a771c32a61148161',
        '373f0994125f9d59423f',
        'b5ae02d1bc7572dcb41f',
        '9069664229ea0fdaee15',
        'd72eadb58ec49a37baf3',
        '67a1ab0fdff60c9cc5ad',
        'cc3a9e6528cae3108820',
        '8bb5585ac11a9260d0be',
        '9a847fd81cf417324549',
        '54ea0ec8e9b314b18d65',
        'a8e2c08d3cf45d13a552',
        'f4d31aa39c09fc4f3d86',
        '9ff57d4606e57c3984c1',
        'e3c28b1ada98ee452448',
        '989f5a5be5516f7d767c',
        'b793246bb71cb547a632',
        'e84c4ffa530aaeb3a110',
        '043f3355b5bc3947fafa',
        'd4ddc1d2def17047d99d',
        'ef423b0d5cf04b91b59f',
        '76236369ebbedf4d4798',
        'e2d436cf5069d0d4ca3c',
        '0766d61665047915d187',
        'dd9a8c6f9b72bfedddda',
        '97cb201e94b97e08dfce',
        'f0f7409ea67c009469b1',
        '149277bd0b14715444dc',
        '6152d0567e13c27b4a95',
        'ddecb5bfba256770862e',
        '52afb56c43bd2242033a',
        '6488eb1246f04ad9c80f',

      ],
      nyyxs:["6e01a530d059118eba95",
        "80894557c5918bb1d957",
        "c32fa84f0b5139687abb",
        "ab82b64630267305c11a",
        "327e54a9ca3b29f2b4b7",
        "46ac92872040dcc7dde6",
        "b8b8e96268b7301f7adc",
        "88ca888e16742f95d1b1",
        "1f0710ee65baa69e6c37",
        "6dbb05e560bd0764afef",
        "8d7448bcfa11dafaa32f",
        "a3813585ab1a48767947",
        "fe222ddd03a4f2b53ee5",
        "b36f543d76122275d7a0",
        "3aade81e71d3fb80e599",
        "1ca585aa3bc5d65a7fb5",
        "1e7120e6801071de6b3e",
        "929435f87aeee1b56499",
        "ac89de8d9fda0b649284",
        "da83c498ce2123da6c0d",
        "dc8ef4f0d521ca51c5a8",
        "bb518c3550c588ce1e7b",
        "c42d591ff71afb578cba",
        "801efc160cddf50bcaf4",
        "85305fd3d2e07dba1676",
        "0f02145c01846416091e",
        "68f18ff45f7724814237",
        "e389f90ce429be5695d3",
        "120502e7c4e0a567730a",
        "0118cc1a328e649cbc9a",
        "66938f7af867220f894f",
        "5b3c9e9537134c2084d4",
        "a773a508ee66449e3512",
        "c47e50b608111a70ae74",
        "440605e3594e5f15d175",
        "ae7281d5b0fff4bdd8dd",
        "b1c87bbf01bf8bdf8516",
        "8e2e06be49e8d431c7c6",
        "916868d4d012e673c56f",
        "8b1402be4458a80d16e4",
        "ee76a1ea1f191ebc0193",
        "9da7ec196a0975b30f6d",
        "13394e658254dfab9691",
        "3fc2594c1655b1f632ba",
        "03b0c34905b1c4b3b005",
        "a1ce0a27510a56787a1f",
        "c06bd755dd3466734c28",
        "0976669359aba7c99cea",
        "46d2daffbc89eab864df",
        "c15f16ab991c845f4875",
        "d89fe1429bf35b21c879",
        "dec194c4554ba62777cf",
        "d1202f675db390851e55",
        "6582c4390100416dfe44",
        "fed32ef2ef2804f2df43",
        "0a82ab7db443ac6b1ae9",
        "86d684b3a4b4fcf6d6b8",
        "2d1d54c57b243455b61b",
        "fb145bb2e15935ef88b1",
        "e4dbf6ce2832ba5d8f67",
        "14c0c0d695e0443999d7",
        "a3165aeda6188d1443d5",
        "df37f47148015b8eead1",
        "cafe7e5e1c578d90a05b",
        "151d4b874df1c5b30467",
        "3d2078c8af3a82180fb4",
        "4c073413072c4778aa37",
        "69e43cd3bf7ae68aee6e",
        "8ee68a47c02e88d16c9f",
        "6702cbb69c9b2b40fc08",
        "09f0fa8ca01c834ea757",
        "d4a68d820ecafc22ff80",
        "cdda4c889f31e876c182",
        "32c0ac5754516f14077f",
        "fc7c7535f0fe35be32e5",


        "09f0fa8ca01c834ea757",
        "d4a68d820ecafc22ff80",
        "cdda4c889f31e876c182",
        "32c0ac5754516f14077f",
        "fc7c7535f0fe35be32e5",
        "7fd0fd41357576b893ed",
        "9f9d224f0a625e6dd50d",
        "f1393259a04f786f4510",
        "295a634cd13478c83295",
        "2b5e719dabb367860ca4",
        "a3fb2e13312e1e229ff5",
        "160036c870daae9c9a79",
        "07f00691b7702f31bf66",
        "816b6847a2915ce27be8",
        "b3375b8f7885ab9eb4ea",
        "2ecc24c1a1d260e1c707",
        "a7029e2455657170c964",
        "90585b4544b7e32dd072",
        "af58632b10cc04baf95d",
        "ba39b4685c7e6cd0e7a1",
        "66388a0b55a0a5e34012",
        "0952cd5dab2b4c609098",
        "1e60be53142b44202439",
        "271e5014fac9f3b6222e",
        "086c8832c8efcaba4e71",
        "2462eaec8354a29ab9d2",
        "2937b55d1dfb9180a683",
        "05834ef5655b75543d29",
        "55762b6e8197808d739c",

      ],
      nyyxstoken:['4744587d6c61bec8ac9be5b9f33b093bc0a87a2bb53ea30fc31ec5786f272326'],

      ssxstoken:['3328c2a371aeb442a465e0a98a9fbcfb1271fad673dc44eb1a47288bb7d91d75','fcc5f91e58bbff33ed8a8b2ef21af243eda73c750db85ce209e0ea9915801819','2822e8218f01a05b0f969b038d3a3bd49ff6e64f965d184b15a9d16fe48711d9'],
      xiaobai:['6dc95a3defa9966711cd4722521bd7c9cf0d4ea90655e8f07bdbf2f50a263955','e28b540298648bd9b4c4f6c7c6ad50f1736c62a9cede45f64658b09ac33946eb','8355c0a7b2624af4b0a042a534d59da737897f72b243fec895a993e4019071a0'],
      dzff:[
        '9f3de3846387ee92da34','edeeee8c21ed473bab7f','0dae3e714fe34f358842','b9abf67c6c208507389e','0881d1c2e5166e297d81','ee99595e7ba3cda29e7c','965929c6a4653dad96e2','291bdba220930273b797','be802921f74b4813d4b2','5c4447c416aaaf4ca3b6','bab533b7ea63797dd0b7','a7718f7e8424ee5447d3','eb9eb702d6026814f900','4cdfa5528fa7a1a5e42f','7a3258b05320496246fa','492f3bd32e48e02b8f72','8fb12f301870f567fb8d','67831d632db305ab3700','95188b35f5adf530433f','9a5b7035ac3b1fd6a916','d37ef586d28ed5c973f9','21d2ef9155ffdd300f08','1ace7b79f7053718f70e','f0a261722748c2c05d57','425b016357e28b137ce9','b52a3c6e3913e254aa81','1858df26596dd2a8caae','1f0ebaa7018bc824e05b','4890ba761e074310e9e4','b17afb61e79ef8e1362b'
      ],
      // mrqy:['7184819045e707d42474','7e1a92bee5d28f0ebd01'],
      mrqy:[
        'b48137cb62870d885265',
        '2ae29945877a5c9a4dc7',
        '2e14d9caaa79a7288945',
        '608cfd23c4899ef21951',
        'def6f567ffb8d43e6cc7',
        '3838db0ef055dcef2d73',
        '5241b2f39d22296ad909',
        '0f4ed863345486fd6566',
        '9b258bcd475d37f2bc17',
        '4304bd9984a383abf7f1',
        'db0492433fd6e9c3ab44',
        '0efb4a6665e5f45d4221',
        'e26f2b1791468c46bef3',
        'a89dcd56fd5db0f5b616',
        '09fd6c45513dce56de4d',
        '4fff6d3089e879810863',
        '9e7cdcd1a5f59d755a56',
        'a21a4926283015f09cc9',
        '03a1e942d33c5947fd8b',
        'ae561695e426daa8aa50',
        'ae42092f88874649a285',
        '54461d32d322ac718a48',
        'dd631409284b309aedef',
        '16ed37dadd53b82072c0',
        '926983ed6481b7b856a8',
        '5fccb9278cb8ab132963',
        '0268bde8b59d63c47a6d',
        '4c323980948ad8f347dd',
        '173f1d77ce7a00833631',
        '1fea626e7d2c50c5a3a2',
        '041228e13e4a0ae34c29',
        'ba0b3afcac862d1a818f',
        '64ddf7a454cb8646a61d',
        '38c00dafbf31b9ceaef6',
        'd73bfec22f9b6f588181',
        'eccc4be71b2f5b7cdd8b',
        '8b4628c4bddb0d3fd7f3',
        '6ff3b3c20faaeeece736',
        'd3035a2bbce5af457b68',
        '2cf37001ae2ab7bd7644',
        '6c33c615b391673106b1',
        '28e4245c0c5d9ec46c14',
        'd02e34c3e915da12e878',
        '23cbcc552564ac0b32e1',
        'cc4d431364a6dc33854f',
        '6f5f2eab7971aa0a6b5b',
        'b02c9d7a802ecb286e43',
        'f0106beaddeff66eac82',
        'b6e3d2ad3d1065dedc23',
        '9d3bb1239409b07fb8dc',
        '48c03389915c645dc0d0',
        '482942cd2c0eb32676a0',
        '22f5db736b71f3f966bf',
        'eb10496395bfb874cade',
        '2828fb55e8cff699699d',
        '57127ea07e1c26419555',
        'b46788c36767c8388b32',
        '6a95628ac5df0d0a182b',
        'b4569ad2007f705c830c',
        '29f714073bd8c2547262',
        '8f8366486ba30532464e',
        'a2741cb1875f4b93680d',
        '5b2ddc744a1749a3a07f',
        'c4eca3e6db65646e2fe7',
        '85005d21d7a2a52434b7',
        '7311a8570ab5f1779dfe',
        '6a7cd85a1aadd8946415',
        '9d1247677840f29331f1',
        'd4978e385ed2d2048fc6',
        '803a0fe8178d01b0b8a1',
        '30f5a74dcd9ca084e4a6',
        '093267d0617e17fe8d45',
        '7e1a92bee5d28f0ebd01',
        '47ca49d978b2c851a7bf',
        '96de265587f5c02ee0f0',
        'f7592977fc08341412e4',
        '374b2fa987a5466a81e6',
        '4b178e3ad44c1a3e3a7b',
        '680675e70cc8fd05a383',
        '56367884530b153adbdc',
        'bb79ada76ed3928b4fba',
        '8d1915fc098712ade5fc',
        '57fcb17abeb2b48d916a',
        '1abffe93a814fe02c9c0',
        '65c80c5a447afe18f23a',
        'c9dadf278b775ea2bf15',
        'c371e29b87cc483cbae3',
        'be07e6cb7ecf711c92a2',
        '7248a6793ccf7babd791',
        '51e1f78ca8272e9e53b4',
        '2b1ad58dc00478bab78f',
        'ea27bad813fc0ecb59c5',
        'c947016142e49180b587',
        '00545aa6a10ac8260571',
        '2fe42740c3fedcaf3083',
        '795add4b50369c7cd451',
        '8c65b4fbad0f4b59afc2',
        'e4e8f626f941e3e0afda',
        'ba1bd0de861517c8c14e',
        '8526a902031077e20b64',
        'afbba1d599de5a1beb44',
        '4601bb3e7fd68afe6916',
        '1fe6142d0b5209e968e5',
        'bce3338c8269b171686b',
        'f6c59b8dd448e662d28d',
        '39d78129b5e402a6168c',
        '8d4e99969a8a9235b432',
        'ade65a17cba3d7cd52f9',
        '7313e88ffcf7153ba33c',
        'f68165e50f5c81d290ce',
        '4d6b5f0f9180e43ea284',
        '3ed29322ec19eddd84a5',
        'a6b53f307734ca6ceb08',
        'b26029813915c6b2b501',
        'ed816a35ace32fa6c180',
        '99b135e185f8c744e079',
        'ea7979e37c54f99bc66d',
        '5ffa264ffbbfa725d30b',
        '7aaf7f546366a23436f1',
        'e855dcf927d4b1999c72',
        '5b1542c0d33fb24be6fb',
        '6add1f28c367ec786e83',
        'ec6fbe3f03c756cd9caf',
        '5bd11b22b6eb9615e5a8',
        '99c7ede18c671f7f1ce0',
        '7184819045e707d42474',
        '01df04d1c86a03a408bd',
        '82afbe16a5febc2f94a1',
        'edb6b0dadb7fa5582505',
        'ba7db98293f76965b053',
        '2feacd2ec1cc3665f24d',
        'f0772a953aabe2ecb039',
        '3a7724f7232fc1dc78a1',
        'e89af6e602a966596878',
        '0e035e5cc02d670c8ad8',
        'a2a1a3a07b3cdef3be7d',
        '9e0eeb0cfdb5c843fa10',
        'b79ec4d6c4c186e2f5a2',
        '9d247cef08b82407e7cf',
        '727a87d20eb346e0f488',
        '71aca1890e8ff242bc02',
        '6596655fc11594c811cc',
        'db81b21357fd08c39ea8',
        '64daf92c52b1a9ed8e3f',
        '25c6f55b21a1228b4780',
        '9c7eac12437ad3962419',
        '8338978946fb42b8b6b2',
        'ad83b3d2e45c37b3eb3a',
        '06fe089672423f124479',
        '841af812aafde46707dc'

      ],


      //
      // qexs:[
      //
      //   '26e0a5da7501231e2e89',
      //
      // ],


      zjsktoken:['bf582040fb08dbe13e7c57d7e2e09910ce704ddcc25ac4d70ba437f43db16adb'],
      zjsk:[
        '97f80e9b6a14761a5ef4',
        'cd7280a61a69e67bc91d',
        'be9b303abc9ab611ca64',
        'adc678a6bfaf8f384f17',
        '2740faec1a5374e8d02f',
        '90e62cf5ca749954f9d3',
        '1d9ea69400f2368efbba',
        'b3118182bdaeaa4de1e3',
        '5a63a861eedddb78eb40',
        '46e299db4c76ef4d4f35',
        'e111a2ca4f07d5101959',
        'c8d2fd9cb7986946e9d9',
        '2bdd2033b5f2ed845f48',
        '3a191e7a2a5ac0e3ae4a',
        'f2d5a09cf1baba9a1df8',
        '9661ba9c8c6dc8fee7b9',
        'b2d5bdc908eeb70d746d',
        '81d0cd40235867c35ddd',
        '2dc696c5860c61f899c6',


      ],

      //  qexs:['a5a031d51f457068eee5'],
      qexs:[
        'e5af9d3f70ae962fca14',
        '9f484087408dc1b5458d',
        'f7acb67d16df1f00c560',
        'e8fe92a9fe526cd47efb',
        '3022de5b7c50f3e9fcae',
        '0ce43822d648f8383a25',
        'a23425abf02b7c01329b',
        '896ccfa3210aea06e220',
        '1fd026e480da72a49018',
        '47bbb1adcdc7c59bb2c8',
        '2c22f3f727df2f97d84e',
        '492389959a35250347eb',
        '8aed5c8c08dc4a21a83f',
        '2531dcd119cc0571e074',
        '70c3e159766973f03a01',
        '7a432a6349b35903fcf2',
        '5c1d77bf9d475a33de7a',
        '40a6325e5404a1eb0d7d',
        '0a0bddb34d657060873d',
        '71dadecb6880327723db',
        'e5aa38ede14eab8e6b54',
        '4363afe08e0944a3db94',
        'cc2f56a78779f44b08ae',
        'a3f2ccc00d596b99ecf9',
        'ba769cbc352f03658ef5',
        'd21ef89d629072d18923',
        'd9085ce1523134a581fc',
        '6af60df7d15c4a11b151',
        '6aebe955371d2deaca8f',
        '7aaac23787fed4726b7c',
        '6f716a4418671c006abc',
        '58096437833c2ca73cc0',
        '5cbc128782ebdeec0d38',
        'fc6b2be6e41db0b07763',
        '7bdb6bf0acb0e8ec91a3',
        'c37867fc17e3c8a20838',
        'beef31aafa55580f7b45',
        '0fb1c3871369b618778a',
        'f672d45a13fd381cf9ee',
        '68929ce880504f751a02',
        'aa6323b5de3a05269980',
        'f93c46d6af2b8f11c6a4',
        '6b7064a31c715c64efa9',
        '17a71026d0c5177b5f33',
        '527bf220a8a36a526c0a',
        'b03c251e07df93baa901',
        '9c3ff015f7dd6f4167c4',
        '9f9c317b4b2a7671135c',
        '950598bcca636adba002',
        '4639811164a071e54a71',
        'd376ba599f9199293e2b',
        'f56438a833492e3335e8',
        'f639d7414d05fbb9ba4c',
        'e158bd6f695f94e3a5ac',
        '055fc090a42e4a80e578',
        'bad9b5083f64efddd7ee',
        '32b2908e4fc589943023',
        'd8ccea57a7e02c2cdbb0',
        '64364de7cfc18498ac9e',
        'fdf38d64009c41aea363',
        '0b8731ebfc20766f5327',
        '9f76a97a136f0c3c70a9',
        '97a2c175cecd7bb1cda2',
        '0288241d375ae2c6a85a',
        'dd90c46d98ba19eef926',
        'f7ca9a8311c57286f4d4',
        '41afaa9f547639b59b26',
        '6218cd9a922e86a7b353',
        '98615d717c259d7b1565',
        '0e237d7a66baef089d7e',
        'bf5023836ad94d777c1c',
        'a8618f17da6096a9cb15',
        'f11344d7192e45fedef7',
        '25e409003f18b157bd41',
        'e8643454e696713be486',
        'dccfe520ab2f5a1a24e1',
        '26ae532eeb34f67c1f32',
        'd59ed93fc6a8815b0d7e',
        'c250a9a76ec62256b397',
        '0aa8e73976a53fbc2a8a',
        'fc592a10c3166a49cc74',
        '9611d40b15f75aca8ecf',
        'eccb4a179f26c8635506',
        'da11966d46aa94276d08',
        '96dae170dda64e602906',
        'cb71bc7d56e8918335a3',
        '1bb631bdfca1824bbdd1',
        'e151aff9ff10c555b3c6',
        '5f129a9f773f006765b7',
        'c4d90b3850e235d95636',
        'c2e0f135a5da9a378b07',
        'e73fb67c9c817dfcc006',
        '048040cce62b3fd5c016',
        'e45de2d6582159cb4e18',
        '8b88beced2a8a794e391',
        '896ada4b3be7a2c17c81',
        '2e814a566224b03757a0',
        '3a9c48134ed3ddc3eae3',
        '2827da338affae3347e8',
        '361b0832aa20c628a5b9',
        '7249bb8394368f6a1dec',
        'a4885cfe70eaa6d0fd6c',
        '9751abb505b53973f5f3',
        '23559002938e12feb685',
        'd2fc8bd8b1b4283d8f6b',
        '2a252a9f5bc87dd8adee',
        '069582676521afc87a7f',
        'e9a4af68113c76b2aa33',
        'e31397872af6f46633fb',
        '724989b3407da2776b53',
        'fd8380c0428458f2599e',
        'a36cc7c1117e31b13450',
        '9863aace4a0dfff2dcb2',
        '1a1b5554aeb7fb574b2a',
        'f4a68381560eb5e9582a',
        '7cca4347521a04a91a9d',
        'f0c5e033e67038aceaa3',
        '63895786446b5d7e97d9',
        'fb575126f968dd4b15ea',
        '941c3887fc7d49058f29',
        '0bcb59e855e30ebff5a9',
        'ce010bb2de0d85b40acc',
        'f6bb448e45b83284bcb6',
        'a02abd06219f8dc9cc90',
        '06fa9762bd9562393fa2',
        '99c73e9ce6e563595651',

        '4bde1fe2054d4d4555eb',
        'cdb788baf2cd37c85f26',
        '0c8cd1f9d91d592f0d06',
        '043f7c4f29ca0eff8586',
        '9f6de4c677f427bb91f6',
        '5066bd6b3560175393f1'
      ],



      //数据
      dingshi:true,
      values: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      time:'',
      value1: '',
      value2: '',
      datas:[],
      datadata:[],
      temp:[],
      temp1:[],
      temp2:[],
      temp3:[],

      startDate:'20220701',
      endDate:'20220710',
      namedata:[],
      datanums:[
        {
          nuMshowCount:0,
          nuMclickCount:0,
          nuMspent:0,
          nuMformsubmitCount:0,
          nuMdisGeneralBalance:0,
          nuMbalance:0,
          nuMcustomPayCount:0,
          nuMreactivation:0,
          nuMcustomRetainCount:0
        }
      ],
      qiliangcode:0,
      sks:'',
      list:[],
      money:200,
      money2:0.5,
      money3:0.0,
      moneys:0.0,
      max:0,
      ctrJson:[{
        nameid:'',
        CTR:0,
        CVR:0,
        CLR:0,
        but:0,
        zdycl:0,
        zdyff:0,
        zdylh:0,
        xe:0,

      }],
      playCode:[],
      Newswicth:[],
      map:new Map,
      groudId:[],
      kaiguan:0,
      adids:'',
      numtest:[],
      planid:[],
      groudId1:[],
      gcj:[]
    }
  },

  filters: {
    formatDateOrError(timestamp) {
      const date = new Date(timestamp);

      // 检查是否为有效日期
      if (isNaN(date.getTime())) {
        return 'Invalid Date';
      }

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');

      return `${year}${month}${day}`;
    }
  }

  ,
  methods:{
    /**一键起量
     *
     *
     * @param pams
     * @returns {Promise<void>}
     * @constructor
     */
    async Postoffer1(pams){
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/updateFastFlow?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "groupId":pams.id,
          "fastFlowBudget":pams.ocpxPrice,
          "fastFlowState":pams.price
        }).then(resp=>{

        console.log(resp.data)
        if (resp.data.code===70111){
          this.$notify.error({
            title: '错误',
            message: '一键起量失败'
          });
        }else {
          this.$notify({
            title: '成功',
            message: '一键起量成功',
            type: 'success'
          });

        }

      })


    },
    async Postoffer(pams){
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/batchEditPrice?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "ids":pams.id,
          "ocpxPrice":pams.ocpxPrice,
          "price":pams.price
        }).then(resp=>{

        console.log(resp.data)
        if (resp.data.code===70111){
          this.$notify.error({
            title: '错误',
            message: '修改二阶段出价失败'
          });
        }else {
          this.$notify({
            title: '成功',
            message: '修改二阶段出价成功',
            type: 'success'
          });

        }

      })


    },
    SendOffer(){
      console.log(this.groudId)
      let t2=this.money3*100000
      let t3=this.money2*100000
      for (let a in this.groudId){
        let t1={
          id:this.groudId[a],
          ocpxPrice:t2,
          price:t3,
          token:this.sks,
          adid:this.adids
        }
        this.Postoffer(t1)
      }

      this.offer=false
    },
    SendOffer1(){
      console.log(this.groudId)
      let t2=this.moneys*100000
      let t3=this.money2*100000
      for (let a in this.groudId){
        let t1={
          id:this.groudId[a],
          ocpxPrice:t2,
          price:1,
          token:this.sks,
          adid:this.adids
        }
        this.Postoffer1(t1)
      }

      this.offer=false
    },
    SendOffer2(){
      console.log(this.groudId)
      let t2=this.moneys*100000
      let t3=this.money2*100000
      for (let a in this.groudId){
        let t1={
          id:this.groudId[a],
          ocpxPrice:t2,
          price:3,
          token:this.sks,
          adid:this.adids
        }
        this.Postoffer1(t1)
      }

      this.offer=false
    },
    async chujia(index, row) {
      this.money3=0;
      this.max=0;
      let pams = {
        //危险
        token: this.sks,
        adid: row.uuid,
        adName: row.adName,
        campaignId: row.campaignId
      }
      this.adids = row.uuid
      await this.PostGroup3(pams)
      await this.yijianqiliangcode(pams)

      this.max=this.numtest[0].ocpxPrice;
      if (this.numtest.length=1){
        this.money3=this.numtest[0].ocpxPrice;
      }else{
        for (let i=1;i<this.numtest.length;i++){
          console.log(this.numtest[i].ocpxPrice)
          if(this.numtest[i].ocpxPrice>this.max){
            this.money3=this.numtest[i].ocpxPrice;
          }else{
            this.money3=this.max

          }

        }
      }

      this.money3=this.money3/100000
      this.offer = true;
    },
    updateEd1(){
      console.log(this.kaiguan)
      if(this.kaiguan===0){
        let t1={
          id:this.grouplist.campaignId,
          dailyBudget:-1,
          token:this.sks,
          adid:this.grouplist.userId
        }
        this.PostMoeny(t1)
      }else if (this.kaiguan===1){
        let t1={
          id:this.grouplist.campaignId,
          dailyBudget:this.money*100000,
          token:this.sks,
          adid:this.grouplist.userId
        }
        this.PostMoeny(t1)


      }



      this.dialog2=false

    },

//修改限额api
    edit1(row){
      console.log(row)
      this.grouplist={}
      this.grouplist={
        campaignId:row.campaignId,
        userId:row.userId,
      }
      this.dialog2=true
    },
    async PostMoeny(pams){
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/campaign/editDailyBudget?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "id":pams.id,
          "dailyBudget":pams.dailyBudget,
        }).then(resp=>{

        console.log(resp.data)
        if (resp.data.code===70111){
          this.$notify.error({
            title: '错误',
            message: '修改限额失败，请检测限额是否错误'
          });
        }else {
          this.$notify({
            title: '成功',
            message: '修改限额成功',
            type: 'success'
          });

        }

      })


    },
    async yijianqiliangcode(pams){
      this.groudId1=[]
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/getFastFlowInfoByGroupIds?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "groupIds":this.groudId[0],
        }).then(resp=>{
        // console.log(resp.data[0].fastFlowState)
        if (resp.data.data===undefined){
          this.qiliangcode=0;
        }else {
          console.log(resp.data.data)
          this.qiliangcode=resp.data.data[0].fastFlowState;


        }
        // if (resp.data.datas[0])
      })


    },
    async PostGroup1(pams){

      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/batchEditDate?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "ids":pams.ids,
          "startDate":pams.startDate,
          "endDate":pams.endDate
        }).then(resp=>{

        if (resp.data.code===70111){
          this.$notify.error({
            title: '错误',
            message: '修改投放日期失败，请检查日期是否错误'
          });
        }else {
          this.$notify({
            title: '成功',
            message: '修改投放日期成功',
            type: 'success',
            position: 'bottom-left'
          });
        }

      })


    },
    async updateTime1() {
      // for(let a=0;a<this.datas.length;a++){
      //   console.log(this.datas[a].uuid)
      // }
      for (let a = 0; a < this.datas.length; a++) {
        this.groudId=[]
        let parms = {
          token: this.sks,
          adid: this.datas[a].uuid,
        }
        // console.log(parms)
        await this.queryPlanId(parms)
        console.log(this.planid)
        for (let key in this.planid) {
          let pams={
            //危险
            token:this.sks,
            adid: this.datas[a].uuid,
            campaignId:this.planid[key],
          }
          this.adids = this.datas[a].uuid,
            await this.PostGroup4(pams)

          // console.log(this.groudId)
        }
        let endtime = '2038-01-19'
        if (this.kaiguan === 0) {
          //发送
          for (let a = 0; a < this.groudId.length; a++) {
            let pams = {
              ids: this.groudId[a],
              startDate: this.value3,
              endDate: endtime,
              token: this.sks,
              adid: this.adids
            }

            await this.PostGroup1(pams)
          }

        } else if (this.kaiguan === 1) {
          for (let a = 0; a < this.groudId.length; a++) {
            let pams = {
              ids: this.groudId[a],
              startDate: this.value2.at(0),
              endDate: this.value2.at(1),
              token: this.sks,
              adid: this.adids
            }
            await  this.PostGroup1(pams)
          }
        }
        if(a===this.datas.length-1){
          alert("批量关闭OK")
          this.dialog3 = false
        }
      }

    },
    //投放时间方法提交
    async updateTime() {
      let endtime = '2038-01-19'
      if (this.kaiguan === 0) {
        //发送
        for (let a = 0; a < this.groudId.length; a++) {
          let pams = {
            ids: this.groudId[a],
            startDate: this.value3,
            endDate: endtime,
            token: this.sks,
            adid: this.adids
          }

          await this.PostGroup1(pams)
        }

      } else if (this.kaiguan === 1) {
        for (let a = 0; a < this.groudId.length; a++) {
          let pams = {
            ids: this.groudId[a],
            startDate: this.value2.at(0),
            endDate: this.value2.at(1),
            token: this.sks,
            adid: this.adids
          }
          await  this.PostGroup1(pams)
        }
      }

      this.dialog1 = false
    },
    //面板状态

    //面板状态
    boo(tab) {
      if(tab.name==="first"){
        this.kaiguan=0
      }else if (tab.name==="erqi"){
        this.kaiguan=12
      }else if (tab.name==="erba"){
        this.kaiguan=13
      }else if (tab.name==="erjiu"){
        this.kaiguan=14
      }else if (tab.name==="ershi"){
        this.kaiguan=15
      }else if (tab.name==="ershiyi"){
        this.kaiguan=16
      }else if (tab.name==="ershier"){
        this.kaiguan=17
      }else if (tab.name==="sanqi"){
        this.kaiguan=18
      }else if (tab.name==="sanba"){
        this.kaiguan=19
      }else if (tab.name==="sanjiu"){
        this.kaiguan=20
      }else if (tab.name==="sanshi"){
        this.kaiguan=21
      }else if (tab.name==="sanshiyi"){
        this.kaiguan=22
      }else if (tab.name==="sanshier"){
        this.kaiguan=23
      }
      else if (tab.name==="second"){
        this.kaiguan=1
      }else if (tab.name==="two"){
        this.kaiguan=2
      }else if(tab.name==="second1"){
        this.kaiguan=3
      }else if(tab.name==="second2"){
        this.kaiguan=4
      }else if(tab.name==="second3"){
        this.kaiguan=5
      }else if(tab.name==="second4"){
        this.kaiguan=6
      }else if(tab.name==="second5"){
      }else if(tab.name==="second5"){
        this.kaiguan=7
      }else if(tab.name==="two2"){
        this.kaiguan=8
      }else if(tab.name==="two4"){
        this.kaiguan=9
      }else if(tab.name==="two5"){
        this.kaiguan=10
      }
      else if(tab.name==="two6"){
        this.kaiguan=11
      }






    },
    //修改日期
    async PostGroupTime(pams){

      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/batchEditTime?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "ids":pams.ids,
          "scheduleTime":pams.scheduleTime,

        }).then(resp=>{

        if (resp.data.code===70111){
          this.$notify.error({
            title: '错误',
            message: '修改投放时段失败，请检查时段是否错误'
          });
        }else {
          this.$notify({
            title: '成功',
            message: '修改投放时段成功',
            type: 'success',
            position: 'bottom-left'
          });
          this.dialog=false
        }

      })


    },
    async PostGroup2(pams){
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/advertisement/pageInfo?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "campaignId":pams.campaignId,
        }).then(resp=>{

        console.log(resp.data.data.list)
        for (let key in resp.data.data.list){
          // this.groudId[key]=resp.data.data.list[key].groupId
          this.groudId.push(resp.data.data.list[key].groupId)
        }

      })

    },
    async PostGroup(pams){
      this.groudId=[]

      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/advertisement/pageInfo?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "campaignId":pams.campaignId,
        }).then(resp=>{

        console.log(resp.data.data.list)
        for (let key in resp.data.data.list){
          this.groudId[key]=resp.data.data.list[key].groupId
        }

      })

    },
    async PostGroup4(pams){
      console.log(pams.campaignId)
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/pageInfo?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "pageIndex": 1,
          "pageSize": 100,
          "campaignId":pams.campaignId,
        }).then(resp=>{
        console.log(resp.data.data)

        for (let key in resp.data.data.list){
          // console.log("广告组id")
          // console.log(resp.data.data.list)
          this.groudId.push(resp.data.data.list[key].id)
        }
        this.numtest=resp.data.data.list

      })
    },
    async PostGroup3(pams){
      this.groudId=[]
      this.value3='';
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/pageInfo?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "campaignId":pams.campaignId,
          "pageIndex": 1,
          "pageSize": 100,
        }).then(resp=>{
        for (let key in resp.data.data.list){
          this.value3=this.timestampToTime(resp.data.data.list[key].startDate)
          this.groudId[key]=resp.data.data.list[key].id
        }
        this.numtest=resp.data.data.list

      })
    },
    //投放时间
    async updateEd() {
      if (this.kaiguan === 0) {
        for (let a = 0; a < this.groudId.length; a++) {
          let parm = {
            token: this.sks,
            adid: this.adids,
            ids: this.groudId[a],
            scheduleTime: '111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111'
          }
          await this.PostGroupTime(parm)
        }

      }  else if (this.kaiguan === 12) {
        for (let a = 0; a < this.groudId.length; a++) {
          let parm = {
            token: this.sks,
            adid: this.adids,
            ids: this.groudId[a],
            scheduleTime: '111100000000001111111111111111111111111111111111111100000000001111111111111111111111111111111111111100000000001111111111111111111111111111111111111100000000001111111111111111111111111111111111111100000000001111111111111111111111111111111111111100000000001111111111111111111111111111111111111100000000001111111111111111111111111111111111'
          }
          await this.PostGroupTime(parm)
        }
      }  else if (this.kaiguan === 13) {
        for (let a = 0; a < this.groudId.length; a++) {
          let parm = {
            token: this.sks,
            adid: this.adids,
            ids: this.groudId[a],
            scheduleTime: '111100000000000011111111111111111111111111111111111100000000000011111111111111111111111111111111111100000000000011111111111111111111111111111111111100000000000011111111111111111111111111111111111100000000000011111111111111111111111111111111111100000000000011111111111111111111111111111111111100000000000011111111111111111111111111111111'
          }
          await this.PostGroupTime(parm)
        }
      }  else if (this.kaiguan === 14) {
        for (let a = 0; a < this.groudId.length; a++) {
          let parm = {
            token: this.sks,
            adid: this.adids,
            ids: this.groudId[a],
            scheduleTime: '111100000000000000111111111111111111111111111111111100000000000000111111111111111111111111111111111100000000000000111111111111111111111111111111111100000000000000111111111111111111111111111111111100000000000000111111111111111111111111111111111100000000000000111111111111111111111111111111111100000000000000111111111111111111111111111111'
          }
          await this.PostGroupTime(parm)
        }
      }  else if (this.kaiguan === 15) {
        for (let a = 0; a < this.groudId.length; a++) {
          let parm = {
            token: this.sks,
            adid: this.adids,
            ids: this.groudId[a],
            scheduleTime: '111100000000000000001111111111111111111111111111111100000000000000001111111111111111111111111111111100000000000000001111111111111111111111111111111100000000000000001111111111111111111111111111111100000000000000001111111111111111111111111111111100000000000000001111111111111111111111111111111100000000000000001111111111111111111111111111'
          }
          await this.PostGroupTime(parm)
        }
      }  else if (this.kaiguan === 16) {
        for (let a = 0; a < this.groudId.length; a++) {
          let parm = {
            token: this.sks,
            adid: this.adids,
            ids: this.groudId[a],
            scheduleTime: '111100000000000000000011111111111111111111111111111100000000000000000011111111111111111111111111111100000000000000000011111111111111111111111111111100000000000000000011111111111111111111111111111100000000000000000011111111111111111111111111111100000000000000000011111111111111111111111111111100000000000000000011111111111111111111111111'
          }
          await this.PostGroupTime(parm)
        }
      }  else if (this.kaiguan === 17) {
        for (let a = 0; a < this.groudId.length; a++) {
          let parm = {
            token: this.sks,
            adid: this.adids,
            ids: this.groudId[a],
            scheduleTime: '111100000000000000000000111111111111111111111111111100000000000000000000111111111111111111111111111100000000000000000000111111111111111111111111111100000000000000000000111111111111111111111111111100000000000000000000111111111111111111111111111100000000000000000000111111111111111111111111111100000000000000000000111111111111111111111111'
          }
          await this.PostGroupTime(parm)
        }
      }  else if (this.kaiguan === 18) {
        for (let a = 0; a < this.groudId.length; a++) {
          let parm = {
            token: this.sks,
            adid: this.adids,
            ids: this.groudId[a],
            scheduleTime: '111111000000001111111111111111111111111111111111111111000000001111111111111111111111111111111111111111000000001111111111111111111111111111111111111111000000001111111111111111111111111111111111111111000000001111111111111111111111111111111111111111000000001111111111111111111111111111111111111111000000001111111111111111111111111111111111'
          }
          await this.PostGroupTime(parm)
        }
      }  else if (this.kaiguan === 19) {
        for (let a = 0; a < this.groudId.length; a++) {
          let parm = {
            token: this.sks,
            adid: this.adids,
            ids: this.groudId[a],
            scheduleTime: '111111000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111'
          }
          await this.PostGroupTime(parm)
        }
      }  else if (this.kaiguan === 20) {
        for (let a = 0; a < this.groudId.length; a++) {
          let parm = {
            token: this.sks,
            adid: this.adids,
            ids: this.groudId[a],
            scheduleTime: '111111000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111'
          }
          await this.PostGroupTime(parm)
        }
      }  else if (this.kaiguan === 21) {
        for (let a = 0; a < this.groudId.length; a++) {
          let parm = {
            token: this.sks,
            adid: this.adids,
            ids: this.groudId[a],
            scheduleTime: '111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111'
          }
          await this.PostGroupTime(parm)
        }
      }  else if (this.kaiguan === 22) {
        for (let a = 0; a < this.groudId.length; a++) {
          let parm = {
            token: this.sks,
            adid: this.adids,
            ids: this.groudId[a],
            scheduleTime: '111111000000000000000011111111111111111111111111111111000000000000000011111111111111111111111111111111000000000000000011111111111111111111111111111111000000000000000011111111111111111111111111111111000000000000000011111111111111111111111111111111000000000000000011111111111111111111111111111111000000000000000011111111111111111111111111'
          }
          await this.PostGroupTime(parm)
        }
      }  else if (this.kaiguan === 23) {
        for (let a = 0; a < this.groudId.length; a++) {
          let parm = {
            token: this.sks,
            adid: this.adids,
            ids: this.groudId[a],
            scheduleTime: '111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111'
          }
          await this.PostGroupTime(parm)
        }
      } else if (this.kaiguan === 1) {
        for (let a = 0; a < this.groudId.length; a++) {
          let parm = {
            token: this.sks,
            adid: this.adids,
            ids: this.groudId[a],
            scheduleTime: '000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111'
          }
          await this.PostGroupTime(parm)
        }
      } else if (this.kaiguan === 2) {
        for (let a = 0; a < this.groudId.length; a++) {
          let parm = {
            token: this.sks,
            adid: this.adids,
            ids: this.groudId[a],
            scheduleTime: '000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111'
          }
          await this.PostGroupTime(parm)
        }
      } else if (this.kaiguan === 3) {
        for (let a = 0; a < this.groudId.length; a++) {
          let parm = {
            token: this.sks,
            adid: this.adids,
            ids: this.groudId[a],
            scheduleTime: '000000000000000011111111111111111111111111111111000000000000000011111111111111111111111111111111000000000000000011111111111111111111111111111111000000000000000011111111111111111111111111111111000000000000000011111111111111111111111111111111000000000000000011111111111111111111111111111111000000000000000011111111111111111111111111111111'
          }
          await this.PostGroupTime(parm)
        }
      } else if (this.kaiguan === 4) {
        for (let a = 0; a < this.groudId.length; a++) {
          let parm = {
            token: this.sks,
            adid: this.adids,
            ids: this.groudId[a],
            scheduleTime: '000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111'
          }
          await this.PostGroupTime(parm)
        }
      } else if (this.kaiguan === 5) {
        for (let a = 0; a < this.groudId.length; a++) {
          let parm = {
            token: this.sks,
            adid: this.adids,
            ids: this.groudId[a],
            scheduleTime: '000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111'
          }
          await this.PostGroupTime(parm)
        }
      } else if (this.kaiguan === 6) {
        for (let a = 0; a < this.groudId.length; a++) {
          let parm = {
            token: this.sks,
            adid: this.adids,
            ids: this.groudId[a],
            scheduleTime: '000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111'
          }
          await this.PostGroupTime(parm)
        }
      } else if (this.kaiguan === 7) {
        for (let a = 0; a < this.groudId.length; a++) {
          let parm = {
            token: this.sks,
            adid: this.adids,
            ids: this.groudId[a],
            scheduleTime: '000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111'
          }
          await this.PostGroupTime(parm)
        }
      } else if (this.kaiguan === 8) {
        for (let a = 0; a < this.groudId.length; a++) {
          let parm = {
            token: this.sks,
            adid: this.adids,
            ids: this.groudId[a],
            scheduleTime: '000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111'
          }
          await this.PostGroupTime(parm)
        }
      } else if (this.kaiguan === 9) {
        for (let a = 0; a < this.groudId.length; a++) {
          let parm = {
            token: this.sks,
            adid: this.adids,
            ids: this.groudId[a],
            scheduleTime: '000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111'
          }
          await this.PostGroupTime(parm)
        }
      } else if (this.kaiguan === 10) {
        for (let a = 0; a < this.groudId.length; a++) {
          let parm = {
            token: this.sks,
            adid: this.adids,
            ids: this.groudId[a],
            scheduleTime: '000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111'
          }
          await this.PostGroupTime(parm)
        }
      } else if (this.kaiguan === 11) {
        for (let a = 0; a < this.groudId.length; a++) {
          let parm = {
            token: this.sks,
            adid: this.adids,
            ids: this.groudId[a],
            scheduleTime: '000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111'
          }
          await this.PostGroupTime(parm)
        }
      }

    },
    //查询计划
    async queryPlanId(parms){
      let time = parseInt(new Date().getTime()) + '';
      let nonce= Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/campaign/pageInfo?access_token=' + parms.token + '&timestamp=' + time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid, {
        pageSize:'100'
      }).then(async resDay => {

        for (let key in resDay.data.data.list){

          this.planid[key]=resDay.data.data.list[key].id
        }

      })

    },
    //显示表单
    async handleClick(row) {
      if (this.values === "ACCOUNT") {
        this.groudId=[]
        let parms = {
          token: this.sks,
          adid: row.uuid,
        }
        await this.queryPlanId(parms)
        this.dialog = true;
        for (let key in this.planid) {
          let pams={
            //危险
            token:this.sks,
            adid:row.uuid,
            campaignId:this.planid[key],
          }
          this.adids = row.uuid

          await this.PostGroup2(pams)

        }
      } else {
        this.dialog = true;
        let pams = {
          //危险
          token: this.sks,
          adid: row.uuid,
          campaignId: row.campaignId,
        }
        this.adids = row.uuid

        await this.PostGroup(pams)
      }


    },

    //投放日期
    async edit(row){
      if (this.values === "ACCOUNT") {
        this.groudId=[]
        let parms = {
          token: this.sks,
          adid: row.uuid,
        }
        // console.log(parms)
        await this.queryPlanId(parms)

        this.dialog1=true;
        console.log(this.planid)
        for (let key in this.planid) {
          let pams={
            //危险
            token:this.sks,
            adid:row.uuid,
            adName:row.adName,
            campaignId:this.planid[key],
          }
          this.adids = row.uuid
          await this.PostGroup4(pams)

          // console.log(this.groudId)
        }
      }else {
        console.log(this.value3)
        let pams={
          //危险
          token:this.sks,
          adid:row.uuid,

          adName:row.adName,
          campaignId:row.campaignId
        }
        this.adids=row.uuid
        this.PostGroup3(pams)
        this.dialog1=true;

      }


    },

    timestampToTime(timestamp) {
      let date = new Date(timestamp)// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + '-'
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      let D = date.getDate() + ' '
      let h = date.getHours() + ':'
      let m = date.getMinutes() + ':'
      let s = date.getSeconds()
      console.log(Y + M + D + h + m + s)
      return Y + M + D
    },

//切换开关
    changeSwitch(value,row,index){
      if (this.userUalue[1]==="mrqy") {
        let time1 = parseInt(new Date().getTime()) + '';
        let nonce = Math.round(Math.random() * 100000000000)
        const {id, pauseState, userId} = row

        let params = {
          userId: userId,
          id: id,
          pauseState: pauseState ? '1' : '0'  // 三元运算符  类似于if else
        };

        this.$axios.post('api/openapi/v1/ad/campaign/pause/toggle?access_token=' + this.sks + '&timestamp=' +
          time1 + '&nonce=' + nonce + '&advertiser_id=' + params.userId, {
          ids: params.id,
          startAndStop: params.pauseState
        }).then(async res => {
          if (res.data.code === 0) {
            this.$message.success(`${pauseState ? '已停用' : '已启用'}`)
          }
        })

      }else {
        let time1 = parseInt(new Date().getTime()) + '';
        let nonce = Math.round(Math.random() * 100000000000)
        const {id, pauseState, userId} = row

        let params = {
          userId: userId,
          id: id,
          pauseState: pauseState ? '1' : '0'  // 三元运算符  类似于if else
        };

        this.$axios.post('api/openapi/v1/ad/campaign/pause/toggle?access_token=' + this.sks + '&timestamp=' +
          time1 + '&nonce=' + nonce + '&advertiser_id=' + params.userId, {
          ids: params.id,
          startAndStop: params.pauseState
        }).then(async res => {
          if (res.data.code === 0) {
            this.$message.success(`${pauseState ? '已停用' : '已启用'}`)
          }
        })

      }

    },
    //汇总 格式化合计行
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      if (this.values==="ACCOUNT"){ //账户层级
        let a=0;

        columns.forEach((column, index) => {

          if (index === 0) {
            sums[index] = '总汇';
            return;
          }

          if (index === 5) {
            sums[index] = sums[index-1]/sums[index-2];
            sums[index]=sums[index].toFixed(3);
            sums[index]=sums[index]*100
            sums[index]= sums[index]+'%'
            sums[index]=sums[index]
            return;

          }

          if(index===8){

            sums[index] = sums[index-2]/sums[index-4];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;
          }
          if (index === 10) {
            sums[index] = sums[index-4]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 12) {
            sums[index] = sums[index-6]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }

          if (index === 15) {
            sums[index] = sums[index-4]/sums[index-11];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]*100
            sums[index]= sums[index]+'%'

            sums[index]=sums[index]
            return;

          }
          if (index === 13) {

            return;

          }
          if (index === 16) {

            return;

          }
          if (index === 7) {

            return;

          }


          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value)) ) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

            sums[index] = sums[index].toFixed(2) + "";
          } else {
            sums[index] = '';
          }

        });
        return sums;
      }
      else if(this.values==="CAMPAIGN"){ //账户层级
        let a=0;

        columns.forEach((column, index) => {

          if (index === 0) {
            sums[index] = '总汇';
            return;
          }

          if (index === 7) {
            sums[index] = sums[index-1]/sums[index-2];
            sums[index]=sums[index].toFixed(3);
            sums[index]=sums[index]*100
            sums[index]= sums[index]+'%'
            sums[index]=sums[index]
            return;

          }

          if(index===10){

            sums[index] = sums[index-2]/sums[index-4];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;
          }
          if (index === 12) {
            sums[index] = sums[index-4]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 14) {
            sums[index] = sums[index-6]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 15) {

            return;

          }
          if (index === 16) {

            return;

          }
          if (index === 17) {

            return;

          }

          if (index === 18) {

            return;

          }
          if (index === 9) {

            return;

          }


          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value)) ) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

            sums[index] = sums[index].toFixed(2) + "";
          } else {
            sums[index] = '';
          }

        });
        return sums;
      }else if(this.values==="GROUP"){ //广告组层级
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总汇';
            return;
          }  if (index === 9) {
            sums[index] = sums[index-2]/sums[index-1];
            sums[index] =  sums[index].toFixed(2) ;
            return;

          }
          if (index === 6) {
            sums[index] = sums[index-1]/sums[index-2];
            sums[index]=sums[index]*100
            sums[index]=sums[index].toFixed(2);
            sums[index]= sums[index]+'%'
            return;

          }
          if (index === 11) {
            sums[index] = sums[index-4]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 13) {
            sums[index] = sums[index-6]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 15) {
            sums[index] = sums[index-8]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 16) {
            sums[index] = sums[index-8]/sums[index-11];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]*100+'%'
            return;

          }
          if (index === 17) {
            sums[index] = sums[index-5]/sums[index-9];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]*100+'%'
            return;

          }



          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value)) ) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

            sums[index] = sums[index].toFixed(2) + "";
          } else {
            sums[index] = '';
          }
        });
        return sums;
      }

    },
    //导出文档api
    exportExcel() {
      excel('exportTab','数据导出')
    },


    //表单格式规则
    rule(row,column){
      if (row[column.property]===undefined){
        return null
      }else {
        var percent = (row[column.property]).toFixed(2)
        return percent
      }
    },
    //加百分号
    ChangeToPercentage: function(row, column) {
      if (row[column.property]===undefined){
        return null
      }else {
        var percent = (row[column.property] * 100).toFixed(2) + '%'
        return percent
      }

    },
    timerule(row,column){
      if (row[column.property]===undefined){
        return  1;
      }else {
        console.log(column.property)
        var ttime = row[column.property];

        var pattern = /(\d{4})(\d{2})(\d{2})/;
        var formatedDate = ttime.toString().replace(pattern, '$1-$2-$3');

        console.log(formatedDate);


        return formatedDate
      }

    },
    rule1(row,column){

      if (row[column.property]===-1){
        return '未限额'
      }else {
        var percent = row[column.property]/100000
        return percent
      }
    },
    // 获取时间戳，获取时间选择器时间
    chooseTimeRange(value1){
      this.time = parseInt(new Date().getTime()) + '';
      this.value2=value1;

    },
    //查询函数
    async getDataList1(){
      this.dialog3=true

    },
    getDataList() {
      //清空列表，数组
      this.time = parseInt(new Date().getTime()) + '';
      this.datanums[0].nuMshowCount=0
      this.datanums[0].nuMclickCount=0
      this.datanums[0].nuMspent=0
      this.datanums[0].nuMformsubmitCount=0
      this.datanums[0].nuMbalance=0
      this.datanums[0].nuMdisGeneralBalance=0
      this.datanums[0].nuMcustomPayCount=0
      this.datanums[0].nuMreactivation=0
      this.datanums[0].nuMcustomRetainCount=0
      this.datas=null
      this.datadata=[]
      this.namedata=[]
      this.playCode=[]
      this.temp2=[]
      this.temp1=[]
      this.temp=[]

      //判断是否为小白进入下方，查询按钮禁用
      if(this.userUalue[0]==="xiaobai"){
        this.isDisable = true
        //调起接口
        this.TimeChangeto1();
      }

    },
    //合并json
    hb(jsonbject1, jsonbject2) {
      var resultJsonObject = {};
      for (var attr in jsonbject1) {
        resultJsonObject[attr] = jsonbject1[attr];
      }
      for (var attr in jsonbject2) {
        resultJsonObject[attr] = jsonbject2[attr];
      }
      return resultJsonObject;
    },
    //按天查询所有户
    async queryDay(list){
      let time = parseInt(new Date().getTime()) + '';
      let nonce= Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/adstatement/summary/query?access_token=' + list.token + '&timestamp=' + time + '&nonce=' + nonce + '&advertiser_id=' + list.adid[list.a], {
        startDate: list.startDate,
        endDate: list.endDate,
        pageIndex: "1",
        pageSize: "100",
        summaryType: "DAY",
        level: list.level
      }).then(async resDay => {
        this.len=resDay.data.data.items.length;
        return resDay;
      })
    },
    //查询广告
    async PostListQuery(parms){

      this.$message.success("正在查询第"+parms.a+"条")
      let time = parseInt(new Date().getTime()) + '';
      let nonce = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/adstatement/summary/query?access_token=' + parms.token + '&timestamp=' + time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid[parms.a], {
        startDate: parms.startDate,
        endDate: parms.endDate,
        pageIndex: "1",
        pageSize: "100",
        summaryType: parms.summaryType,
        level: parms.level
      }).then(async resp => {

        if (resp.data.code!==60806){
          if (resp.data.data.items !=null){
            if (this.value==="HOUR"){
              let arr=[];
              arr=[];
              let map=new Map;
              map.clear();
              for(let key in resp.data.data.items){
                var time=new Date(resp.data.data.items[key].reportTime)
                let reTimeHour=time.getHours(); //获取返回整点时间
                var date=new Date()
                let hour=date.getHours();  // 获取当前时间
                if (hour===reTimeHour){
                  arr.push(key)   //定位现在整时位置
                  map.set(key,resp.data.data.items[key])// 记录下现在的数据
                }
              }
              for (let keys in arr){

                this.datadata.push(map.get(arr[keys]))
                let obj={
                  ids:resp.data.data.items[arr[keys]].campaignId,
                  lengths:arr.length
                }
                let pams=Object.assign(obj,parms)
                await this.PostListplayCode(pams)
              }
              let obj1={
                lengths:arr.length
              }
              parms=Object.assign(obj1,parms)
              await this.GetListUserId(parms);

            }
            else{
              for (let b=0;b<resp.data.data.items.length;b++){
                this.datadata.push(resp.data.data.items[b])
                let obj={
                  ids:resp.data.data.items[b].campaignId,
                  lengths:resp.data.data.items.length
                }
                let pams=Object.assign(obj,parms)
                await this.PostListplayCode(pams)
                await this.groupcj(pams);
              }
              let obj1={
                lengths:resp.data.data.items.length
              }
              parms=Object.assign(obj1,parms)
              await this.GetListUserId(parms);


            }

          }
        }

      })

    },
    // 查询计划状态
    async PostListplayCode(pams){
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/campaign/pageInfo?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid[pams.a],
        {
          "ids":pams.ids,
        }).then(resps=>{
        if (resps.data.data.list===undefined){
          this.playCode.push({pauseState:1})
        }else {
          this.playCode.push(resps.data.data.list[0])
        }
      })
    },
    //查询账号信息
    async GetListUserId(parms){
      let time = parseInt(new Date().getTime()) + '';
      let nonce = Math.round(Math.random() * 100000000000)
      await this.$axios.get('api/openapi/v1/account/fetch?access_token=' + parms.token + '&timestamp=' + time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid[parms.a])
        .then(async res => {
            if (res.data.message == '请求成功') {
              //测试
              if (this.value==="HOUR"){
                for (let e=0;e<parms.lengths;e++){
                  this.namedata.push(res.data.data)
                }
              }else{
                for (let e=0;e<parms.lengths;e++){
                  this.namedata.push(res.data.data)
                }
              }
            } else {

            }
          }

        )
    },
    //查询广告组出价
    async groupcj(parms){
      let nonce = Math.round(Math.random() * 100000000000)
      let time = parseInt(new Date().getTime()) + '';
      await this.$axios.post('api/openapi/v1/ad/group/pageInfo?access_token=' + parms.token + '&timestamp=' + time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid[parms.a]
        ,{
          "pageIndex": 1,
          "pageSize": 20,
          "adGroupStatus": 0,
          "campaignId":parms.ids
        })
        .then(async res => {
            this.gcj.push(res.data.data.list[0].ocpxPrice)
          }

        )
    },
    //服务请求
    async TimeChangeto1 () {
      //判断是哪个户
      this.sks=this.xiaobai[0]
      if (this.userUalue[1]==="mrqy"){
        for (let a = 0; a < this.mrqy.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.mrqy
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        this.temp4 = JSON.parse(JSON.stringify(this.gcj))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].groupcjj=this.temp4[key]/100000
          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))

        this.datas=this.temp2
        this.isDisable = false

      }   if (this.userUalue[1]==="xsdq"){
        this.sks=this.xsdqtoken[0]
        for (let a = 0; a < this.xsdq.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.xsdq
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        console.log(this.temp1)
        this.temp4 = JSON.parse(JSON.stringify(this.gcj))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].groupcjj=this.temp4[key]/100000
          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp1[key].dataVersion=this.temp1[key].dailyBudget
          //wzs
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].backActivateCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        console.log(this.temp2)
        this.datas=this.temp2
        this.isDisable = false

      }


      if (this.userUalue[1]==="wxqk"){
        this.sks=this.wxqktoken[0]
        for (let a = 0; a < this.wxqk.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.wxqk
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        console.log(this.temp1)
        this.temp4 = JSON.parse(JSON.stringify(this.gcj))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].groupcjj=this.temp4[key]/100000

          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp1[key].dataVersion=this.temp1[key].dailyBudget
          //wzs
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].backActivateCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        console.log(this.temp2)
        this.datas=this.temp2
        this.isDisable = false

      }


      if (this.userUalue[1]==="fxdj"){
        this.sks=this.fxdjtoken[0]
        for (let a = 0; a < this.fxdj.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.fxdj
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        console.log(this.temp1)
        this.temp4 = JSON.parse(JSON.stringify(this.gcj))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].groupcjj=this.temp4[key]/100000
          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp1[key].dataVersion=this.temp1[key].dailyBudget
          //wzs
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].backActivateCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        console.log(this.temp2)
        this.datas=this.temp2
        this.isDisable = false

      }

      if (this.userUalue[1]==="fjsk"){
        this.sks=this.fjsktoken[0]
        for (let a = 0; a < this.fjsk.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.fjsk
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        console.log(this.temp1)
        this.temp4 = JSON.parse(JSON.stringify(this.gcj))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].groupcjj=this.temp4[key]/100000

          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp1[key].dataVersion=this.temp1[key].dailyBudget
          //wzs
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].backActivateCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        console.log(this.temp2)
        this.datas=this.temp2
        this.isDisable = false

      }
      if (this.userUalue[1]==="qexs"){
        this.sks=this.xiaobai[1]
        for (let a = 0; a < this.qexs.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.qexs
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        this.temp4 = JSON.parse(JSON.stringify(this.gcj))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].groupcjj=this.temp4[key]/100000
          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }
      if (this.userUalue[1]==="xgjc"){
        this.sks=this.xgjctoken[0]
        for (let a = 0; a < this.xgjc.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.xgjc
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        this.temp4 = JSON.parse(JSON.stringify(this.gcj))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].groupcjj=this.temp4[key]/100000
          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }





















      if (this.userUalue[1]==="hutao"){
        this.sks=this.hutaotoken[0]
        for (let a = 0; a < this.hutao.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.hutao
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        this.temp4 = JSON.parse(JSON.stringify(this.gcj))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].groupcjj=this.temp4[key]/100000
          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }if (this.userUalue[1]==="nyyxs"){
        this.sks=this.nyyxstoken[0]
        for (let a = 0; a < this.nyyxs.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.nyyxs
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        this.temp4 = JSON.parse(JSON.stringify(this.gcj))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].groupcjj=this.temp4[key]/100000
          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }









      if (this.userUalue[1]==="shengmi"){
        this.sks=this.shengmitoken[0]
        for (let a = 0; a < this.shengmi.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.shengmi
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        this.temp4 = JSON.parse(JSON.stringify(this.gcj))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].groupcjj=this.temp4[key]/100000
          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }

      if (this.userUalue[1]==="mtjc"){
        this.sks=this.mtjctoken[0]
        for (let a = 0; a < this.mtjc.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.mtjc
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        this.temp4 = JSON.parse(JSON.stringify(this.gcj))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].groupcjj=this.temp4[key]/100000
          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }

      if (this.userUalue[1]==="feimao"){
        this.sks=this.feimaotoken[0]
        for (let a = 0; a < this.feimao.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.feimao
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        this.temp4 = JSON.parse(JSON.stringify(this.gcj))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].groupcjj=this.temp4[key]/100000
          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }









      if (this.userUalue[1]==="zxyd"){
        this.sks=this.zxydtoken[0]
        for (let a = 0; a < this.zxyd.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.zxyd
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        this.temp4 = JSON.parse(JSON.stringify(this.gcj))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].groupcjj=this.temp4[key]/100000

          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }

      if (this.userUalue[1]==="qkdj"){
        this.sks=this.qkdjtoken[0]
        for (let a = 0; a < this.qkdj.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.qkdj
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        this.temp4 = JSON.parse(JSON.stringify(this.gcj))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].groupcjj=this.temp4[key]/100000

          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }

      if (this.userUalue[1]==="qdxs"){
        this.sks=this.qdxstoken[0]
        for (let a = 0; a < this.qdxs.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.qdxs
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        this.temp4 = JSON.parse(JSON.stringify(this.gcj))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].groupcjj=this.temp4[key]/100000
          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }

      if (this.userUalue[1]==="fhlm"){
        this.sks=this.fhlmtoken[0]
        for (let a = 0; a < this.fhlm.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.fhlm
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        this.temp4 = JSON.parse(JSON.stringify(this.gcj))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].groupcjj=this.temp4[key]/100000

          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }
      if (this.userUalue[1]==="pfcx"){
        this.sks=this.fhxstoken[0]
        for (let a = 0; a < this.pfcx.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.pfcx
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        this.temp4 = JSON.parse(JSON.stringify(this.gcj))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].groupcjj=this.temp4[key]/100000
          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }

      if (this.userUalue[1]==="xsyd"){
        this.sks=this.xsydtoken[0]
        for (let a = 0; a < this.xsyd.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.xsyd
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        this.temp4 = JSON.parse(JSON.stringify(this.gcj))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          console.log(this.temp4[key])
          this.ctrJson[0].groupcjj=this.temp4[key]/100000

          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }
      if (this.userUalue[1]==="fhxs"){
        this.sks=this.fhxstoken[0]
        for (let a = 0; a < this.fhxs.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.fhxs
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        this.temp4 = JSON.parse(JSON.stringify(this.gcj))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          console.log(this.temp4[key])
          this.ctrJson[0].groupcjj=this.temp4[key]/100000

          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }
      if (this.userUalue[1]==="czjc"){
        this.sks=this.czjctoken[0]
        for (let a = 0; a < this.czjc.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.czjc
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        this.temp4 = JSON.parse(JSON.stringify(this.gcj))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].groupcjj=this.temp4[key]/100000

          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }
      if (this.userUalue[1]==="hmxs"){
        this.sks=this.hmxstoken[0]
        for (let a = 0; a < this.hmxs.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.hmxs
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        this.temp4 = JSON.parse(JSON.stringify(this.gcj))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].groupcjj=this.temp4[key]/100000
          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }
      if (this.userUalue[1]==="ssxs"){
        this.sks=this.ssxstoken[0]
        for (let a = 0; a < this.ssxs.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.ssxs
          }
          await this.PostListQuery(parms)
        }

        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        console.log(this.temp1)
        this.temp4 = JSON.parse(JSON.stringify(this.gcj))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].groupcjj=this.temp4[key]/100000

          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp1[key].dataVersion=this.temp1[key].dailyBudget
          //wzs
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        console.log(this.temp2)
        this.datas=this.temp2
        this.isDisable = false

      }
      if (this.userUalue[1]==="jhcm"){
        this.sks=this.jhcmtoken[0]
        for (let a = 0; a < this.jhcm.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.jhcm
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        console.log(this.temp1)
        this.temp4 = JSON.parse(JSON.stringify(this.gcj))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].groupcjj=this.temp4[key]/100000

          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp1[key].dataVersion=this.temp1[key].dailyBudget
          //wzs
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        console.log(this.temp2)
        this.datas=this.temp2
        this.isDisable = false

      }

      if (this.userUalue[1]==="zjsk"){
        this.sks=this.zjsktoken[0]
        for (let a = 0; a < this.zjsk.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.zjsk
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        console.log(this.temp1)
        this.temp4 = JSON.parse(JSON.stringify(this.gcj))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].groupcjj=this.temp4[key]/100000

          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp1[key].dataVersion=this.temp1[key].dailyBudget
          //wzs
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        console.log(this.temp2)
        this.datas=this.temp2
        this.isDisable = false

      }
      if (this.userUalue[1]==="klks"){
        this.sks=this.klkstoken[0]
        for (let a = 0; a < this.klks.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.klks
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        this.temp4 = JSON.parse(JSON.stringify(this.gcj))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].groupcjj=this.temp4[key]/100000
          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }
      if (this.userUalue[1]==="xqqqexs"){
        this.sks=this.ssxstoken[0]
        for (let a = 0; a < this.xqqqexs.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.xqqqexs
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        this.temp4 = JSON.parse(JSON.stringify(this.gcj))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].groupcjj=this.temp4[key]/100000
          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }
      if (this.userUalue[1]==="xqqhmxs"){
        this.sks=this.ssxstoken[1]
        for (let a = 0; a < this.xqqhmxs.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.xqqhmxs
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        this.temp4 = JSON.parse(JSON.stringify(this.gcj))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].groupcjj=this.temp4[key]/100000
          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }
      if (this.userUalue[1]==="xqqhtxs"){
        this.sks=this.ssxstoken[2]
        for (let a = 0; a < this.xqqhtxs.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.xqqhtxs
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        this.temp4 = JSON.parse(JSON.stringify(this.gcj))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].groupcjj=this.temp4[key]/100000
          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }
      if (this.userUalue[1]==="chssxs"){
        this.sks=this.ssxstoken[0]
        for (let a = 0; a < this.ch.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.ch
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        this.temp4 = JSON.parse(JSON.stringify(this.gcj))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].groupcjj=this.temp4[key]/100000
          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }
      if (this.userUalue[1]==="hxzssxs"){
        this.sks=this.ssxstoken[0]
        for (let a = 0; a < this.hxz.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.hxz
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        this.temp4 = JSON.parse(JSON.stringify(this.gcj))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].groupcjj=this.temp4[key]/100000
          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }
      if (this.userUalue[1]==="whssxs"){
        this.sks=this.ssxstoken[0]
        for (let a = 0; a < this.wh.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.wh
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        this.temp4 = JSON.parse(JSON.stringify(this.gcj))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].groupcjj=this.temp4[key]/100000
          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }
      if (this.userUalue[1]==="dzff"){
        this.sks=this.xiaobai[2]
        for (let a = 0; a < this.dzff.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.dzff
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        this.temp4 = JSON.parse(JSON.stringify(this.gcj))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].groupcjj=this.temp4[key]/100000
          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }
      if (this.userUalue[1]==="modj"){
        this.sks=this.modjtoken[0]
        for (let a = 0; a < this.modj.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.modj
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        this.temp4 = JSON.parse(JSON.stringify(this.gcj))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].groupcjj=this.temp4[key]/100000

          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }

    },
  },
  created () {  },
}

</script>




































// WEBPACK FOOTER //
// src/components/xiaobai.vue